// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var $$String = require("rescript/lib/js/string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var DOM$SmartcutsMacros = require("./DOM.bs.js");
var Rect$SmartcutsMacros = require("./Rect.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var DOM__Node$SmartcutsMacros = require("./DOM__Node.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var AuthStatus$SmartcutsMacros = require("./AuthStatus.bs.js");
var DOM__Event$SmartcutsMacros = require("./DOM__Event.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var RenderOnHost$SmartcutsMacros = require("./RenderOnHost.bs.js");
var SelectorTree$SmartcutsMacros = require("../../bs-select/src/SelectorTree.bs.js");
var StateMachine$SmartcutsMacros = require("./StateMachine.bs.js");
var Modal__WebAuth$SmartcutsMacros = require("./Modal__WebAuth.bs.js");
var DOM__FocusTrail$SmartcutsMacros = require("./DOM__FocusTrail.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var SideEffectGroup$SmartcutsMacros = require("./SideEffectGroup.bs.js");
var ClipboardHelpers$SmartcutsMacros = require("./ClipboardHelpers.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("./DOM__HtmlElement.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("./semantics/InnerTextSemantic.bs.js");
var SelectorOverrides$SmartcutsMacros = require("./commands/shared/SelectorOverrides.bs.js");
var PendingCommandInfo$SmartcutsMacros = require("./PendingCommandInfo.bs.js");
var Virtualized__Input$SmartcutsMacros = require("./Virtualized__Input.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var Selection__Snapshot$SmartcutsMacros = require("./Selection/Selection__Snapshot.bs.js");
var CommandPlaybackRuntime$SmartcutsMacros = require("./CommandPlaybackRuntime.bs.js");
var RenderOnHost__Geometry$SmartcutsMacros = require("./RenderOnHost__Geometry.bs.js");
var Virtualized__InputMaps$SmartcutsMacros = require("./Virtualized__InputMaps.bs.js");
var HighlightElement__Shared$SmartcutsMacros = require("./HighlightElement__Shared.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var MultiUrlTriggering__Types$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Types.bs.js");
var MultiUrlTriggering__Shared$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Shared.bs.js");
var RenderOnHost__Notification$SmartcutsMacros = require("./RenderOnHost__Notification.bs.js");
var ExtensionMessaging__FromTab$SmartcutsMacros = require("./ExtensionMessaging__FromTab.bs.js");
var DOM__Event__ForSerialization$SmartcutsMacros = require("./DOM__Event__ForSerialization.bs.js");
var SelectorOverrideWithoutScope$SmartcutsMacros = require("./commands/shared/SelectorOverrideWithoutScope.bs.js");
var Virtualized__ContentEditable$SmartcutsMacros = require("./Virtualized__ContentEditable.bs.js");
var BgFx__UserCredentials__Shared$SmartcutsMacros = require("./Bg/Fx/BgFx__UserCredentials__Shared.bs.js");
var StateMachine__DebounceManager$SmartcutsMacros = require("./StateMachine__DebounceManager.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("./InterfaceBtwnContentScriptAndBg.bs.js");
var DataExtraction__DataRecord__Types$SmartcutsMacros = require("../../bs-data-extraction/src/DataExtraction__DataRecord__Types.bs.js");
var ContentScript__StateMachine__Types$SmartcutsMacros = require("./ContentScript/StateMachine/ContentScript__StateMachine__Types.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("./ContentScript/StateMachine/ContentScript__StateMachine__Shared__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros = require("./ContentScript/StateMachine/RecordingMode/ContentScript__StateMachine__RecordingMode__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = require("./ContentScript/StateMachine/RecordingMode/ContentScript__StateMachine__RecordingMode__Shared.bs.js");
var ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros = require("./ContentScript/StateMachine/UrlTriggeringMode/ContentScript__StateMachine__UrlTriggeringMode__Types.bs.js");
var ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros = require("./ContentScript/StateMachine/DataExtractionMode/ContentScript__StateMachine__DataExtractionMode__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__GoogleSheets__Types$SmartcutsMacros = require("./ContentScript/StateMachine/RecordingMode/ContentScript__StateMachine__RecordingMode__GoogleSheets__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__ContentEditing__Types$SmartcutsMacros = require("./ContentScript/StateMachine/RecordingMode/ContentScript__StateMachine__RecordingMode__ContentEditing__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__EventStreaming__Types$SmartcutsMacros = require("./ContentScript/StateMachine/RecordingMode/ContentScript__StateMachine__RecordingMode__EventStreaming__Types.bs.js");

var ContentScript__StateMachine__PlaybackMode__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      94,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "stringifyReaonNotPlaybackCommand"
        ],
        [
          /* Function */0,
          "stringifyState"
        ],
        [
          /* Function */0,
          "stringifyFailure"
        ],
        [
          /* Function */0,
          "stringifyExitReason"
        ],
        [
          /* Function */0,
          "stringifyEvent"
        ],
        [
          /* Function */0,
          "stringifySideEffect"
        ],
        [
          /* Function */0,
          "mapState"
        ],
        [
          /* Function */0,
          "mapEvent"
        ],
        [
          /* Function */0,
          "mapSideEffect"
        ]
      ]
    });

var ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      791,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyFailure"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareListenerForSerialization"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    });

var ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      1685,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "stringifyFailure"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareFailureForSerialization"
              ],
              [
                /* Function */0,
                "prepareExitReasonForSerialization"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    });

var ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      2883,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyFailure"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    });

var ContentScript__StateMachine__RecordingMode__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      4169,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyParallelState"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareExitReasonForSerialization"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    });

var ContentScript__StateMachine__Shared__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      5222,
      4
    ], {
      TAG: /* Module */0,
      _0: [[
          /* Function */0,
          "stringifyEvent"
        ]]
    });

var ContentScript__StateMachine__Types__Helpers = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      5507,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyOtherFailureReason"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyErrorContext"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapErrorContext"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyErrorContext"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareListenerForSerialization"
              ],
              [
                /* Function */0,
                "prepareErrorContextForSerialization"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyErrorContext"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyFailureInfo"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    });

var ExtensionMessagingLogging = Caml_module.init_mod([
      "ExtensionMessagingAndStateMachineTypes.re",
      7444,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StartStreamingEventsToBackground"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StopStreamingEventsToBackground"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "Playback"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "PlaybackExited"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "RenderInContentScript"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskContentScriptToAdjustModalGeometry"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskContentScriptToEnterUrlTriggeringMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_RefreshLinks"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_UpdateLinks"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_TellTabToUpdateLinkGroups"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_Exit"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskContentScriptToRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_StopRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_PlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_DidFinishPlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_ShowLinkWithId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_SendContextLocalAndLinkGroups"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_PrepareForScreenshot"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "PingTab"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DoesElementExistOnPage"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToRenderModalToExplainHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToSetupHighlightElementControl"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToTeardownHighlightElementControl"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToEnterDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToExitDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "All"
              ]
            ]
          },
          "FromExtension"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ContentScriptReady"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToRefreshAuthStatus"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToFetchPlanSubscriptionProgress"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyBgOfContentScriptFailure"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyBgOfContentScriptResponseFailure"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StartDebugSelector"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StartRecording"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StopRecording"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DidStartRecording"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyBgAboutPossibleCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ClearKeyThatDoesNotGenerateCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "RecordCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FinishAuthoring"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "OpenPageForSmartcutId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ShowFormForSmartcutId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToAdjustModalGeometry"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "InitializePlayback"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetAuthoringCommandLog"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetMySmartcuts"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "InstallSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DeleteSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetExecutionHistoryForSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetScheduledTriggersForSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FindExecutionById"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UpdateExecutionStatus"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UpsertExecutionSet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DeleteExecutionSet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetExecutionSetProgress"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetExecutionSetById"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UpsertScheduledTriggerAndCreateAlarm"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ArchiveScheduledTrigger"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "SaveExternalAccount"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FindExternalAccountById"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetOAuthToken"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToClipboard"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "CreateGoogleSheet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FetchGoogleSheet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "BatchUpdateGoogleSheet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "InitGoogleAuthFlow"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UserDidCloseGoogleOAuthModal"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "MultiUrlTriggering"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DebugSelector"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "PlaybackModeControl"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToUpdateLinkGroups"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToStopRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToPlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_DidFinishPlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToShowLinkWithId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_MaybeReadyToPlaybackPagination"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToUpdatePaginateFn"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToFocusTab"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToFocusWindow"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "SmartcutSavingProgress"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "RequestPermissions"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyConfirmExecutionQuotaResult"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "TrackWithSegment"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UserReadyLogInToWebsite"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "OpenNewWindow"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StoreAuthStatusItem"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DidCloseExplainModalAndAskBgToHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToStopHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetUserCredentials"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UnlockVaultWithMasterSecret"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ModifyUserCredentials"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgIfMasterSecretDoesExist"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgForMissingPasswords"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToCreateVaultWithMasterSecret"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToResetMasterSecret"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToDetachLoginSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToEnterDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToProcessDataExtractionSignal"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToExitFromDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToRenderNotification"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToSaveDataExtractionAsSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "All"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AllAll"
              ]
            ]
          },
          "FromTab"
        ]
      ]
    });

function stringifyReaonNotPlaybackCommand(reason) {
  if (typeof reason === "number") {
    switch (reason) {
      case /* NotSupported */0 :
          return "Not supported";
      case /* TabOrWindowNotVisible */1 :
          return "TabOrWindowNotVisible";
      case /* TabOrWindowVisibilityUnknownOrUnloaded */2 :
          return "TabOrWindowVisibilityUnknownOrUnloaded";
      
    }
  } else {
    switch (reason.TAG | 0) {
      case /* SearchElementTimedOut */0 :
          var match = reason._0;
          return "SearchElementTimedOut({selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, match.selector) + (", ms: " + (match.ms.toString() + "})")));
      case /* QuerySelectorOverridesTimedOut */1 :
          return "QuerySelectorOverridesTimedOut(" + (Belt_Array.map(reason._0, SelectorOverrideWithoutScope$SmartcutsMacros.toString).join(", ") + ")");
      case /* CouldNotApplySemantic */2 :
          return "CouldNotApplySemantic(semanticError)";
      case /* OverlayStillBlockingElementAfterMs */3 :
          var match$1 = reason._0;
          return "OverlayStillBlockingElementAfterMs({element: " + (match$1.element + (", maybeOverlayElement: " + (OptionUtils$SmartcutsMacros.withDefault("None", match$1.maybeOverlayElement) + (", ms: " + (match$1.ms.toString() + "})")))));
      case /* ErrorWhileSearchForElement */4 :
          return "ErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + ")");
      case /* ErrorWhileWaitForPossibleOverlayToDisappear */5 :
          return "ErrorWhileWaitForPossibleOverlayToDisappear(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + ")");
      case /* RanIntoUnhandledPromiseError */6 :
          return "RanIntoUnhandledPromiseError(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, reason._0) + ")");
      
    }
  }
}

function stringifyUrlTriggerAfterExit(stringifyHtmlElement, param) {
  return "{ triggeringElement: " + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyTriggeringElement(stringifyHtmlElement, param.triggeringElement) + " }");
}

function stringifyExited(stringifyHtmlElement, param) {
  return "{ maybeUrlTriggerAfterExit: " + (OptionUtils$SmartcutsMacros.stringify((function (param) {
                  return stringifyUrlTriggerAfterExit(stringifyHtmlElement, param);
                }), param.maybeUrlTriggerAfterExit) + " }");
}

function stringifyExiting(stringifyHtmlElement, stringifyDomEvent, param) {
  return "{ allExitReasons: " + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                  return stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, param);
                }), param.allExitReasons) + (", maybeUrlTriggerAfterExit: " + (OptionUtils$SmartcutsMacros.stringify((function (param) {
                      return stringifyUrlTriggerAfterExit(stringifyHtmlElement, param);
                    }), param.maybeUrlTriggerAfterExit) + (", didDetachListeners: " + (Pervasives.string_of_bool(param.didDetachListeners) + (", nRemainingDebouncedTimeers: " + (String(param.nRemainingDebouncedTimeers) + " }")))))));
}

function stringifyState(stringifyHtmlElement, stringifyDomEvent, param) {
  var mode = param.mode;
  var playbackWarningModalState = param.playbackWarningModalState;
  var tmp;
  if (typeof mode === "number") {
    tmp = mode === /* Init */0 ? "Init" : "WaitingForNextCommand";
  } else {
    switch (mode.TAG | 0) {
      case /* PlayingBackCommand */0 :
          tmp = "PlayingBackCommand(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, mode._0) + ")");
          break;
      case /* Exiting */1 :
          tmp = "Exiting(" + (stringifyExiting(stringifyHtmlElement, stringifyDomEvent, mode._0) + ")");
          break;
      case /* Exited */2 :
          tmp = "Exited(" + (stringifyExited(stringifyHtmlElement, mode._0) + ")");
          break;
      
    }
  }
  return "{ mode: " + (tmp + (", playbackWarningModalState: " + ((
                playbackWarningModalState ? "ShowingPlaybackWarningModal({len: " + (String(Belt_MapString.size(playbackWarningModalState._0)) + "})") : "HidingSmartcutsPlaybackWarningModal"
              ) + "}")));
}

function stringifyFailure(stringifyHtmlElement, stringifyDomEvent, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithoutListener.stringify, (function (param) {
                return stringifyState(stringifyHtmlElement, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, param);
              }), (function (param) {
                return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}

function stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, exitReason) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.stringify, (function (param) {
                return stringifyState(stringifyHtmlElement, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, param);
              }), (function (param) {
                return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}

function stringifyEvent(stringifyHtmlElement, stringifyDomEvent, $$event) {
  if (typeof $$event === "number") {
    switch ($$event) {
      case /* Initialize */0 :
          return "Initialize";
      case /* DidAttachListeners */1 :
          return "DidAttachListeners";
      case /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */2 :
          return "ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand";
      case /* DidDetachListeners */3 :
          return "DidDetachListeners";
      case /* DidStartCollectingDataRecords */4 :
          return "DidStartCollectingDataRecords";
      case /* DidFinishCollectingDataRecords */5 :
          return "DidFinishCollectingDataRecords";
      
    }
  } else {
    switch ($$event.TAG | 0) {
      case /* DidPlaybackCommand */0 :
          return "DidPlaybackCommand(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, $$event._0) + ")");
      case /* DidntPlaybackCommand */1 :
          return "DidntPlaybackCommand(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, $$event._0) + (", reason=" + (stringifyReaonNotPlaybackCommand($$event._1) + ")")));
      case /* BasicEventWhilePlayback */2 :
          return "BasicEventWhilePlayback(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
      case /* DomEvent */3 :
          return "DomEvent(" + (Curry._1(stringifyDomEvent, $$event._0) + (", " + ($$event._1.toString() + ")")));
      case /* DidSetNewDebounceTimeout */4 :
          return "DidSetNewDebounceTimeout(" + ($$event._0 + ", timeoutId)");
      case /* DebounceTimerExpired */5 :
          return "DebounceTimerExpired(" + ($$event._0 + ")");
      case /* DidFlushDebouncedEvent */6 :
          return "DidFlushDebouncedEvent(entry)";
      case /* DidClearDebounceTimeout */7 :
          return "DidClearDebounceTimeout(" + ($$event._0 + ")");
      case /* IgnoreSubtreesWithCollectedDataRecords */8 :
          return "IgnoreSubtreesWithCollectedDataRecords([n=" + (String($$event._0.length) + ")");
      case /* Fail */9 :
          return "Fail(" + (stringifyFailure(stringifyHtmlElement, stringifyDomEvent, $$event._0) + ")");
      case /* Exit */10 :
          return "Exit(" + (stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, $$event._0) + ")");
      
    }
  }
}

function stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* AttachListeners */0 :
          return "AttachListeners";
      case /* RenderPlaybackModal */1 :
          return "RenderPlaybackModal";
      case /* RemovePlaybackModal */2 :
          return "RemovePlaybackModal";
      case /* RenderDataExtractionOverlay */3 :
          return "RenderDataExtractionOverlay";
      case /* RemoveDataExtractionOverlay */4 :
          return "RemoveDataExtractionOverlay";
      case /* DetachListeners */5 :
          return "DetachListeners";
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return "Dispatch(" + (stringifyEvent(stringifyHtmlElement, stringifyDomEvent, sideEffect._0) + ")");
      case /* PlaybackCommandAndRespondToBg */1 :
          return "PlaybackCommandAndRespondToBg(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, sideEffect._0) + ", playbackOptions, preconditions, respondToBg)");
      case /* RespondToBg */2 :
          return "RespondToBg(respondToBg, " + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, sideEffect._1) + ")");
      case /* ResetDebounceTimeout */3 :
          return "ResetDebounceTimeout(" + (sideEffect._0 + (", maybePreviouseTimeoutId=" + OptionUtils$SmartcutsMacros.stringify((function (param) {
                            return "timeoutId";
                          }), sideEffect._1)));
      case /* ClearDebounceTimeout */4 :
          return "ClearDebounceTimeout(" + (sideEffect._0 + ", timeoutId)");
      
    }
  }
}

function mapPlaybackModalState(mapDomEvent, playbackWarningModalState) {
  if (playbackWarningModalState) {
    return /* ShowingPlaybackWarningModal */{
            _0: StateMachine__DebounceManager$SmartcutsMacros.map(mapDomEvent, (function (param) {
                    
                  }), playbackWarningModalState._0)
          };
  } else {
    return /* HidingSmartcutsPlaybackWarningModal */0;
  }
}

function mapState(mapHtmlElement, mapDomEvent, param) {
  var mode = param.mode;
  var tmp;
  if (typeof mode === "number") {
    tmp = mode === /* Init */0 ? /* Init */0 : /* WaitingForNextCommand */1;
  } else {
    switch (mode.TAG | 0) {
      case /* PlayingBackCommand */0 :
          tmp = {
            TAG: /* PlayingBackCommand */0,
            _0: mode._0
          };
          break;
      case /* Exiting */1 :
          var match = mode._0;
          tmp = {
            TAG: /* Exiting */1,
            _0: {
              maybeUrlTriggerAfterExit: Belt_Option.map(match.maybeUrlTriggerAfterExit, (function (param) {
                      return {
                              triggeringElement: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapTriggeringElement(mapHtmlElement, param.triggeringElement),
                              respondToBg: param.respondToBg,
                              isPlaybackMode: param.isPlaybackMode
                            };
                    })),
              didDetachListeners: match.didDetachListeners,
              nRemainingDebouncedTimeers: match.nRemainingDebouncedTimeers,
              allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, mapExitReason(mapHtmlElement, mapDomEvent), match.allExitReasons)
            }
          };
          break;
      case /* Exited */2 :
          tmp = {
            TAG: /* Exited */2,
            _0: {
              maybeUrlTriggerAfterExit: Belt_Option.map(mode._0.maybeUrlTriggerAfterExit, (function (param) {
                      return {
                              triggeringElement: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapTriggeringElement(mapHtmlElement, param.triggeringElement),
                              respondToBg: param.respondToBg,
                              isPlaybackMode: param.isPlaybackMode
                            };
                    }))
            }
          };
          break;
      
    }
  }
  return {
          playbackWarningModalState: mapPlaybackModalState(mapDomEvent, param.playbackWarningModalState),
          mode: tmp,
          paginateState: {
            subtreesWithCollectedDataRecords: Belt_Array.map(param.paginateState.subtreesWithCollectedDataRecords, mapHtmlElement)
          }
        };
}

function mapEvent(mapHtmlElement, mapDomEvent, $$event) {
  if (typeof $$event === "number") {
    switch ($$event) {
      case /* Initialize */0 :
          return /* Initialize */0;
      case /* DidAttachListeners */1 :
          return /* DidAttachListeners */1;
      case /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */2 :
          return /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */2;
      case /* DidDetachListeners */3 :
          return /* DidDetachListeners */3;
      case /* DidStartCollectingDataRecords */4 :
          return /* DidStartCollectingDataRecords */4;
      case /* DidFinishCollectingDataRecords */5 :
          return /* DidFinishCollectingDataRecords */5;
      
    }
  } else {
    switch ($$event.TAG | 0) {
      case /* DidPlaybackCommand */0 :
          return {
                  TAG: /* DidPlaybackCommand */0,
                  _0: $$event._0
                };
      case /* DidntPlaybackCommand */1 :
          return {
                  TAG: /* DidntPlaybackCommand */1,
                  _0: $$event._0,
                  _1: $$event._1
                };
      case /* BasicEventWhilePlayback */2 :
          return {
                  TAG: /* BasicEventWhilePlayback */2,
                  _0: $$event._0
                };
      case /* DomEvent */3 :
          return {
                  TAG: /* DomEvent */3,
                  _0: Curry._1(mapDomEvent, $$event._0),
                  _1: $$event._1
                };
      case /* DidSetNewDebounceTimeout */4 :
          return {
                  TAG: /* DidSetNewDebounceTimeout */4,
                  _0: $$event._0,
                  _1: $$event._1
                };
      case /* DebounceTimerExpired */5 :
          return {
                  TAG: /* DebounceTimerExpired */5,
                  _0: $$event._0
                };
      case /* DidFlushDebouncedEvent */6 :
          return {
                  TAG: /* DidFlushDebouncedEvent */6,
                  _0: StateMachine__DebounceManager$SmartcutsMacros.mapEntry(mapDomEvent, (function (param) {
                          
                        }), $$event._0)
                };
      case /* DidClearDebounceTimeout */7 :
          return {
                  TAG: /* DidClearDebounceTimeout */7,
                  _0: $$event._0
                };
      case /* IgnoreSubtreesWithCollectedDataRecords */8 :
          return {
                  TAG: /* IgnoreSubtreesWithCollectedDataRecords */8,
                  _0: Belt_Array.map($$event._0, mapHtmlElement)
                };
      case /* Fail */9 :
          return {
                  TAG: /* Fail */9,
                  _0: Curry._1(mapFailure(mapHtmlElement, mapDomEvent), $$event._0)
                };
      case /* Exit */10 :
          return {
                  TAG: /* Exit */10,
                  _0: Curry._1(mapExitReason(mapHtmlElement, mapDomEvent), $$event._0)
                };
      
    }
  }
}

function mapFailure(mapHtmlElement, mapDomEvent) {
  return Curry._3(StateMachine$SmartcutsMacros.Failure.WithoutListener.map, (function (param) {
                return mapState(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapEvent(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect(mapHtmlElement, mapDomEvent, param);
              }));
}

function mapExitReason(mapHtmlElement, mapDomEvent) {
  return Curry._3(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.map, (function (param) {
                return mapState(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapEvent(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect(mapHtmlElement, mapDomEvent, param);
              }));
}

function mapSideEffect(mapHtmlElement, mapDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* AttachListeners */0 :
          return /* AttachListeners */0;
      case /* RenderPlaybackModal */1 :
          return /* RenderPlaybackModal */1;
      case /* RemovePlaybackModal */2 :
          return /* RemovePlaybackModal */2;
      case /* RenderDataExtractionOverlay */3 :
          return /* RenderDataExtractionOverlay */3;
      case /* RemoveDataExtractionOverlay */4 :
          return /* RemoveDataExtractionOverlay */4;
      case /* DetachListeners */5 :
          return /* DetachListeners */5;
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return {
                  TAG: /* Dispatch */0,
                  _0: mapEvent(mapHtmlElement, mapDomEvent, sideEffect._0)
                };
      case /* PlaybackCommandAndRespondToBg */1 :
          return {
                  TAG: /* PlaybackCommandAndRespondToBg */1,
                  _0: sideEffect._0,
                  _1: sideEffect._1,
                  _2: sideEffect._2,
                  _3: sideEffect._3
                };
      case /* RespondToBg */2 :
          return {
                  TAG: /* RespondToBg */2,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* ResetDebounceTimeout */3 :
          return {
                  TAG: /* ResetDebounceTimeout */3,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* ClearDebounceTimeout */4 :
          return {
                  TAG: /* ClearDebounceTimeout */4,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      
    }
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "stringifyReaonNotPlaybackCommand"
        ],
        [
          /* Function */0,
          "stringifyState"
        ],
        [
          /* Function */0,
          "stringifyFailure"
        ],
        [
          /* Function */0,
          "stringifyExitReason"
        ],
        [
          /* Function */0,
          "stringifyEvent"
        ],
        [
          /* Function */0,
          "stringifySideEffect"
        ],
        [
          /* Function */0,
          "mapState"
        ],
        [
          /* Function */0,
          "mapEvent"
        ],
        [
          /* Function */0,
          "mapSideEffect"
        ]
      ]
    }, ContentScript__StateMachine__PlaybackMode__Types__Helpers, {
      stringifyReaonNotPlaybackCommand: stringifyReaonNotPlaybackCommand,
      stringifyState: stringifyState,
      stringifyFailure: stringifyFailure,
      stringifyExitReason: stringifyExitReason,
      stringifyEvent: stringifyEvent,
      stringifySideEffect: stringifySideEffect,
      mapState: mapState,
      mapEvent: mapEvent,
      mapSideEffect: mapSideEffect
    });

function stringifyListener(stringifyDomMutationRecord, listener) {
  if (listener.TAG === /* DocumentBodyMutationObserverListener */0) {
    return "DocumentBodyMutationObserverListener([" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(stringifyDomMutationRecord, listener._0))) + "])");
  } else {
    return "ContentEditableMutationObserverListener([" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(stringifyDomMutationRecord, listener._0))) + "])");
  }
}

function stringifyState$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, state) {
  if (typeof state === "number") {
    if (state === /* Init */0) {
      return "Init";
    } else {
      return "NotEditing";
    }
  }
  switch (state.TAG | 0) {
    case /* WaitMutationObserverAttachTo */0 :
        return "WaitMutationObserverAttachTo(contentEditableHost=" + (Curry._1(stringifyDomHtmlElement, state._0) + ")");
    case /* EditingContentEditable */1 :
        return "EditingContentEditable(virtualizedContentEditable=" + (Virtualized__ContentEditable$SmartcutsMacros.Generic.stringify(stringifyDomHtmlElement, stringifyDomNode, state._0) + ", _disconnect)");
    case /* Exiting */2 :
        return "Exiting(respondToBg)";
    case /* Exited */3 :
        return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                        return stringifyExitReason$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
                      }), state._0) + ")");
    
  }
}

function stringifyEvent$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event) {
  if (typeof $$event === "number") {
    if ($$event === /* Initialize */0) {
      return "Initialize";
    } else {
      return "MutationObserved";
    }
  }
  switch ($$event.TAG | 0) {
    case /* SharedEvent */0 :
        return "SharedEvent(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement, stringifyDomEvent, $$event._0) + ")");
    case /* BasicEventWhileContentEditing */1 :
        return "BasicEventWhileContentEditing(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
    case /* FocusOnContentEditable */2 :
        return "FocusOnContentEditable(" + (Curry._1(stringifyDomNode, $$event._0) + ")");
    case /* MutationObserverAttachedTo */3 :
        return "MutationObserverAttachedTo(contentEditableHost=" + (Curry._1(stringifyDomHtmlElement, $$event._0) + ", disconnect)");
    case /* Fail */4 :
        return "Fail(" + (stringifyFailure$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event._0) + ")");
    case /* Exit */5 :
        return "Exit(" + (stringifyExitReason$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event._0) + ")");
    
  }
}

function stringifySideEffect$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, sideEffect) {
  switch (sideEffect.TAG | 0) {
    case /* Dispatch */0 :
        return "Dispatch(" + (stringifyEvent$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, sideEffect._0) + ")");
    case /* SetupMutationObserver */1 :
        return "SetupMutationObserver(contentEditableHost=" + (Curry._1(stringifyDomHtmlElement, sideEffect._0) + ")");
    case /* TearDownMutationObserver */2 :
        return "TearDownMutationObserver(disconnect)";
    
  }
}

function stringifyFailure$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, failure) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, (function (param) {
                return stringifyState$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyEvent$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifySideEffect$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyListener(stringifyDomMutationRecord, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}

function stringifyExitReason$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, exitReason) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, (function (param) {
                return stringifyState$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyEvent$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifySideEffect$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyListener(stringifyDomMutationRecord, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}

function mapListener(mapDomMutationRecord, listener) {
  if (listener.TAG === /* DocumentBodyMutationObserverListener */0) {
    return {
            TAG: /* DocumentBodyMutationObserverListener */0,
            _0: $$Array.map(mapDomMutationRecord, listener._0)
          };
  } else {
    return {
            TAG: /* ContentEditableMutationObserverListener */1,
            _0: $$Array.map(mapDomMutationRecord, listener._0)
          };
  }
}

function mapState$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, state) {
  if (typeof state === "number") {
    if (state === /* Init */0) {
      return /* Init */0;
    } else {
      return /* NotEditing */1;
    }
  }
  switch (state.TAG | 0) {
    case /* WaitMutationObserverAttachTo */0 :
        return {
                TAG: /* WaitMutationObserverAttachTo */0,
                _0: Curry._1(mapDomHtmlElement, state._0)
              };
    case /* EditingContentEditable */1 :
        return {
                TAG: /* EditingContentEditable */1,
                _0: Virtualized__ContentEditable$SmartcutsMacros.Generic.map(mapDomHtmlElement, mapDomNode, state._0),
                _1: state._1
              };
    case /* Exiting */2 :
        return {
                TAG: /* Exiting */2,
                _0: {
                  allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                          return mapExitReason$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
                        }), state._0.allExitReasons)
                }
              };
    case /* Exited */3 :
        return {
                TAG: /* Exited */3,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                        return mapExitReason$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
                      }), state._0)
              };
    
  }
}

function mapEvent$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event) {
  if (typeof $$event === "number") {
    if ($$event === /* Initialize */0) {
      return /* Initialize */0;
    } else {
      return /* MutationObserved */1;
    }
  }
  switch ($$event.TAG | 0) {
    case /* SharedEvent */0 :
        return {
                TAG: /* SharedEvent */0,
                _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement, mapDomEvent, $$event._0)
              };
    case /* BasicEventWhileContentEditing */1 :
        return {
                TAG: /* BasicEventWhileContentEditing */1,
                _0: $$event._0
              };
    case /* FocusOnContentEditable */2 :
        return {
                TAG: /* FocusOnContentEditable */2,
                _0: Curry._1(mapDomNode, $$event._0)
              };
    case /* MutationObserverAttachedTo */3 :
        return {
                TAG: /* MutationObserverAttachedTo */3,
                _0: Curry._1(mapDomHtmlElement, $$event._0),
                _1: $$event._1
              };
    case /* Fail */4 :
        return {
                TAG: /* Fail */4,
                _0: mapFailure$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    case /* Exit */5 :
        return {
                TAG: /* Exit */5,
                _0: mapExitReason$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    
  }
}

function mapSideEffect$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, sideEffect) {
  switch (sideEffect.TAG | 0) {
    case /* Dispatch */0 :
        return {
                TAG: /* Dispatch */0,
                _0: mapEvent$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, sideEffect._0)
              };
    case /* SetupMutationObserver */1 :
        return {
                TAG: /* SetupMutationObserver */1,
                _0: Curry._1(mapDomHtmlElement, sideEffect._0)
              };
    case /* TearDownMutationObserver */2 :
        return {
                TAG: /* TearDownMutationObserver */2,
                _0: sideEffect._0
              };
    
  }
}

function mapFailure$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, (function (param) {
                return mapState$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapEvent$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapListener(mapDomMutationRecord, param);
              }), failure);
}

function mapExitReason$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, exitReason) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, (function (param) {
                return mapState$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapEvent$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapListener(mapDomMutationRecord, param);
              }), exitReason);
}

var stringifyDomMutationRecord = DOM$SmartcutsMacros.$$MutationRecord.stringify;

function stringifyState$2(param) {
  return stringifyState$1(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord, DOM__Event$SmartcutsMacros.stringify, param);
}

function stringifyEvent$2(param) {
  return stringifyEvent$1(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord, DOM__Event$SmartcutsMacros.stringify, param);
}

function stringifySideEffect$2(param) {
  return stringifySideEffect$1(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord, DOM__Event$SmartcutsMacros.stringify, param);
}

function stringifyListener$1(param) {
  return stringifyListener(stringifyDomMutationRecord, param);
}

var stringifyDomHtmlElement = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;

var stringifyDomNode = DOM__Node$SmartcutsMacros.ForSerialization.stringify;

var stringifyDomMutationRecord$1 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify;

function stringifyState$3(param) {
  return stringifyState$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord$1, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}

function stringifyEvent$3(param) {
  return stringifyEvent$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord$1, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}

function stringifySideEffect$3(param) {
  return stringifySideEffect$1(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord$1, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}

function stringifyListener$2(param) {
  return stringifyListener(stringifyDomMutationRecord$1, param);
}

var mapDomHtmlElement = DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement;

var mapDomNode = DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode;

var mapDomMutationRecord = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord;

var mapDomEvent = DOM__Event__ForSerialization$SmartcutsMacros.make;

function prepareStateForSerialization(state) {
  return mapState$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, state);
}

function prepareEventForSerialization($$event) {
  return mapEvent$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event);
}

function prepareSideEffectForSerialization(sideEffect) {
  return mapSideEffect$1(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, sideEffect);
}

function prepareListenerForSerialization(listener) {
  return mapListener(mapDomMutationRecord, listener);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyFailure"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareListenerForSerialization"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    }, ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers, {
      Generic: {
        stringifyListener: stringifyListener,
        stringifyState: stringifyState$1,
        stringifyEvent: stringifyEvent$1,
        stringifySideEffect: stringifySideEffect$1,
        stringifyFailure: stringifyFailure$1,
        stringifyExitReason: stringifyExitReason$1,
        mapListener: mapListener,
        mapState: mapState$1,
        mapEvent: mapEvent$1,
        mapSideEffect: mapSideEffect$1,
        mapFailure: mapFailure$1,
        mapExitReason: mapExitReason$1
      },
      Regular: {
        stringifyState: stringifyState$2,
        stringifyEvent: stringifyEvent$2,
        stringifySideEffect: stringifySideEffect$2,
        stringifyListener: stringifyListener$1
      },
      ForSerialization: {
        stringifyState: stringifyState$3,
        stringifyEvent: stringifyEvent$3,
        stringifySideEffect: stringifySideEffect$3,
        stringifyListener: stringifyListener$2,
        prepareStateForSerialization: prepareStateForSerialization,
        prepareEventForSerialization: prepareEventForSerialization,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization,
        prepareListenerForSerialization: prepareListenerForSerialization
      }
    });

function mapListener$1(mapDomEvent, listener) {
  return /* DOMEventListener */{
          _0: Curry._1(mapDomEvent, listener._0)
        };
}

function mapState$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, state) {
  if (typeof state === "number") {
    if (state === /* Init */0) {
      return /* Init */0;
    } else {
      return /* SettingUpEventStreamingToBg */1;
    }
  }
  switch (state.TAG | 0) {
    case /* StreamingEventsToBg */0 :
        return {
                TAG: /* StreamingEventsToBg */0,
                _0: mapStreamingState(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, state._0)
              };
    case /* HighlightingElementWhileStreamingEventsToBg */1 :
        return {
                TAG: /* HighlightingElementWhileStreamingEventsToBg */1,
                _0: mapStreamingState(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, state._0),
                _1: state._1
              };
    case /* Exiting */2 :
        var match = state._0;
        return {
                TAG: /* Exiting */2,
                _0: {
                  didTeardownEventStreaming: match.didTeardownEventStreaming,
                  debounceStatusForExit: mapDebounceStatusForExit(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, match.debounceStatusForExit),
                  allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                          return mapExitReason$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
                        }), match.allExitReasons)
                }
              };
    case /* Exited */3 :
        return {
                TAG: /* Exited */3,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                        return mapExitReason$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
                      }), state._0)
              };
    
  }
}

function mapStreamingState(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param) {
  var func = function (param, param$1) {
    return StateMachine__DebounceManager$SmartcutsMacros.map(mapDomEvent, param, param$1);
  };
  return {
          inputByDomElementRepresentation: Curry._1(mapInputByDomElementRepresentation, param.inputByDomElementRepresentation),
          currentSelection: Selection__Snapshot$SmartcutsMacros.Generic.map(mapDomNode, param.currentSelection),
          focusTrail: List.map((function (param) {
                  return DOM__FocusTrail$SmartcutsMacros.Item.map(mapDomHtmlElement, param);
                }), param.focusTrail),
          maybeClickContext: Belt_Option.map(param.maybeClickContext, mapDomEvent),
          debounceManager: Curry._2(func, (function (firstCallData) {
                  return {
                          pendingCommandKey: firstCallData.pendingCommandKey,
                          focusTrail: List.map((function (param) {
                                  return DOM__FocusTrail$SmartcutsMacros.Item.map(mapDomHtmlElement, param);
                                }), firstCallData.focusTrail),
                          firstTimestamp: firstCallData.firstTimestamp
                        };
                }), param.debounceManager)
        };
}

function mapDebounceStatusForExit(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, exitingSubState) {
  if (exitingSubState) {
    return /* AwaitingAllDebouncedEventsToFlush */{
            _0: mapStreamingState(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, exitingSubState._0)
          };
  } else {
    return /* FlushedAllDebouncedEvents */0;
  }
}

function mapEvent$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, $$event) {
  if (typeof $$event === "number") {
    switch ($$event) {
      case /* DidSetupEventStreaming */0 :
          return /* DidSetupEventStreaming */0;
      case /* DidTeardownEventStreaming */1 :
          return /* DidTeardownEventStreaming */1;
      case /* ShouldNotShowUserExplainHighlightModal */2 :
          return /* ShouldNotShowUserExplainHighlightModal */2;
      
    }
  } else {
    switch ($$event.TAG | 0) {
      case /* Initialize */0 :
          return {
                  TAG: /* Initialize */0,
                  _0: $$event._0
                };
      case /* DidSetNewDebounceTimeout */1 :
          return {
                  TAG: /* DidSetNewDebounceTimeout */1,
                  _0: $$event._0,
                  _1: $$event._1
                };
      case /* DebounceTimerExpired */2 :
          return {
                  TAG: /* DebounceTimerExpired */2,
                  _0: $$event._0
                };
      case /* DidFlushDebouncedEvent */3 :
          return {
                  TAG: /* DidFlushDebouncedEvent */3,
                  _0: StateMachine__DebounceManager$SmartcutsMacros.mapEntry(mapDomEvent, (function (firstCallData) {
                          return {
                                  pendingCommandKey: firstCallData.pendingCommandKey,
                                  focusTrail: List.map((function (param) {
                                          return DOM__FocusTrail$SmartcutsMacros.Item.map(mapDomHtmlElement, param);
                                        }), firstCallData.focusTrail),
                                  firstTimestamp: firstCallData.firstTimestamp
                                };
                        }), $$event._0)
                };
      case /* UserDidSelectElement */4 :
          return {
                  TAG: /* UserDidSelectElement */4,
                  _0: Curry._1(mapDomHtmlElement, $$event._0)
                };
      case /* SharedEvent */5 :
          return {
                  TAG: /* SharedEvent */5,
                  _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement, mapDomEvent, $$event._0)
                };
      case /* BasicEventWhileEventStreaming */6 :
          return {
                  TAG: /* BasicEventWhileEventStreaming */6,
                  _0: $$event._0
                };
      case /* Fail */7 :
          return {
                  TAG: /* Fail */7,
                  _0: mapFailure$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, $$event._0)
                };
      case /* Exit */8 :
          return {
                  TAG: /* Exit */8,
                  _0: mapExitReason$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, $$event._0)
                };
      
    }
  }
}

function mapFailure$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, (function (param) {
                return mapState$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
              }), (function (param) {
                return mapEvent$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
              }), (function (param) {
                return mapSideEffect$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
              }), (function (param) {
                return mapListener$1(mapDomEvent, param);
              }), failure);
}

function mapExitReason$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, exitReason) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, (function (param) {
                return mapState$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
              }), (function (param) {
                return mapEvent$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
              }), (function (param) {
                return mapSideEffect$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param);
              }), (function (param) {
                return mapListener$1(mapDomEvent, param);
              }), exitReason);
}

function mapSideEffect$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* SetupEventStreaming */0 :
          return /* SetupEventStreaming */0;
      case /* TeardownEventStreaming */1 :
          return /* TeardownEventStreaming */1;
      case /* RenderModalToExplainHighlightElement */2 :
          return /* RenderModalToExplainHighlightElement */2;
      case /* RenderHighlightElementControl */3 :
          return /* RenderHighlightElementControl */3;
      case /* RemoveRenderedContent */4 :
          return /* RemoveRenderedContent */4;
      case /* TellBgToStopHighlightingElement */5 :
          return /* TellBgToStopHighlightingElement */5;
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return {
                  TAG: /* Dispatch */0,
                  _0: mapEvent$2(mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, sideEffect._0)
                };
      case /* StreamCommandToBgToRecordIt */1 :
          return {
                  TAG: /* StreamCommandToBgToRecordIt */1,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* NotifyBgAboutPossibleCommand */2 :
          return {
                  TAG: /* NotifyBgAboutPossibleCommand */2,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* ResetDebounceTimeout */3 :
          return {
                  TAG: /* ResetDebounceTimeout */3,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* RespondToBg */4 :
          return {
                  TAG: /* RespondToBg */4,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* StreamCommandToBgForHighlightedElement */5 :
          return {
                  TAG: /* StreamCommandToBgForHighlightedElement */5,
                  _0: Curry._1(mapDomHtmlElement, sideEffect._0),
                  _1: sideEffect._1
                };
      case /* RetrievePossibleCommandInfoAndMaybeStreamToBg */6 :
          return {
                  TAG: /* RetrievePossibleCommandInfoAndMaybeStreamToBg */6,
                  _0: sideEffect._0,
                  _1: sideEffect._1,
                  _2: sideEffect._2
                };
      
    }
  }
}

function stringifyListener$3(stringifyDomEvent, listener) {
  return "DOM.listen(timestamp, domEvent=" + (Curry._1(stringifyDomEvent, listener._0) + ") for listener setup as a result of SetupEventStreaming");
}

function stringifyState$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, state) {
  var stringifyStreamingState = function (param) {
    return "{inputByDomElementRepresentation: " + (Curry._1(stringifyInputByDomElementRepresentation, param.inputByDomElementRepresentation) + (", currentSelection: " + (Selection__Snapshot$SmartcutsMacros.Generic.stringify(stringifyDomNode, param.currentSelection) + (", maybeClickContext: " + (OptionUtils$SmartcutsMacros.stringify(stringifyDomEvent, param.maybeClickContext) + (", debounceManager({len: " + (String(StateMachine__DebounceManager$SmartcutsMacros.size(param.debounceManager)) + "})}")))))));
  };
  if (typeof state === "number") {
    if (state === /* Init */0) {
      return "Init";
    } else {
      return "SettingUpEventStreamingToBg";
    }
  }
  switch (state.TAG | 0) {
    case /* StreamingEventsToBg */0 :
        return "StreamingEventsToBg(" + (stringifyStreamingState(state._0) + ")");
    case /* HighlightingElementWhileStreamingEventsToBg */1 :
        return "HighlightingElementWhileStreamingEventsToBg(" + (stringifyStreamingState(state._0) + (", callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(state._1) + ")")));
    case /* Exiting */2 :
        var match = state._0;
        var debounceStatusForExit = match.debounceStatusForExit;
        var tmp;
        if (debounceStatusForExit) {
          var match$1 = debounceStatusForExit._0;
          tmp = "AwaitingAllDebouncedEventsToFlush({inputByDomElementRepresentation: " + (Curry._1(stringifyInputByDomElementRepresentation, match$1.inputByDomElementRepresentation) + (", currentSelection: " + (Selection__Snapshot$SmartcutsMacros.Generic.stringify(stringifyDomNode, match$1.currentSelection) + (", maybeClickContext: " + ((
                      match$1.maybeClickContext !== undefined ? "Some(domEvent)" : "None"
                    ) + (", debounceManager({len: " + (String(StateMachine__DebounceManager$SmartcutsMacros.size(match$1.debounceManager)) + "})})")))))));
        } else {
          tmp = "FlushedAllDebouncedEvents";
        }
        return "Exiting({didTeardownEventStreaming: " + (Pervasives.string_of_bool(match.didTeardownEventStreaming) + (", debounceStatusForExit: " + (tmp + ", allExitReasons})")));
    case /* Exited */3 :
        return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                        return stringifyExitReason$2(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
                      }), state._0) + ")");
    
  }
}

function stringifyExitReason$2(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, exitReason) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, (function (param) {
                return stringifyState$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
              }), (function (param) {
                return stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
              }), (function (param) {
                return stringifySideEffect$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
              }), (function (param) {
                return stringifyListener$3(stringifyDomEvent, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}

function stringifyFailure$2(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, failure) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, (function (param) {
                return stringifyState$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
              }), (function (param) {
                return stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
              }), (function (param) {
                return stringifySideEffect$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param);
              }), (function (param) {
                return stringifyListener$3(stringifyDomEvent, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}

function stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, $$event) {
  if (typeof $$event === "number") {
    switch ($$event) {
      case /* DidSetupEventStreaming */0 :
          return "DidSetupEventStreaming";
      case /* DidTeardownEventStreaming */1 :
          return "DidTeardownEventStreaming";
      case /* ShouldNotShowUserExplainHighlightModal */2 :
          return "ShouldNotShowUserExplainHighlightModal";
      
    }
  } else {
    switch ($$event.TAG | 0) {
      case /* Initialize */0 :
          if ($$event._0 !== undefined) {
            return "Initialize(respondToBg, rejectToBg)";
          } else {
            return "Initialize(None)";
          }
      case /* DidSetNewDebounceTimeout */1 :
          return "DidSetNewDebounceTimeout(" + ($$event._0 + (", " + (String($$event._1) + ")")));
      case /* DebounceTimerExpired */2 :
          return "DebounceTimerExpired(" + ($$event._0 + ")");
      case /* DidFlushDebouncedEvent */3 :
          return "DidFlushDebouncedEvent(" + (Curry._1(stringifyDomEvent, $$event._0.event) + ")");
      case /* UserDidSelectElement */4 :
          return "UserDidSelectElement(htmlElement)";
      case /* SharedEvent */5 :
          return "SharedEvent(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement, stringifyDomEvent, $$event._0) + ")");
      case /* BasicEventWhileEventStreaming */6 :
          return "BasicEventWhileEventStreaming(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
      case /* Fail */7 :
          return "Fail(" + (stringifyFailure$2(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, $$event._0) + ")");
      case /* Exit */8 :
          return "Exit(" + (stringifyExitReason$2(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, $$event._0) + ")");
      
    }
  }
}

function stringifySideEffect$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* SetupEventStreaming */0 :
          return "SetupEventStreaming";
      case /* TeardownEventStreaming */1 :
          return "TeardownEventStreaming";
      case /* RenderModalToExplainHighlightElement */2 :
          return "RenderModalToExplainHighlightElement";
      case /* RenderHighlightElementControl */3 :
          return "RenderHighlightElementControl";
      case /* RemoveRenderedContent */4 :
          return "RemoveRenderedContent";
      case /* TellBgToStopHighlightingElement */5 :
          return "TellBgToStopHighlightingElement";
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return "Dispatch(" + (stringifyEvent$4(stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, sideEffect._0) + ")");
      case /* StreamCommandToBgToRecordIt */1 :
          var arg = OptionUtils$SmartcutsMacros.map(sideEffect._1, (function (param) {
                  return "(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(param[0]) + (", " + String(param[1])));
                }));
          return "StreamCommandToBgToRecordIt(commandWithContextLocal where command=" + (Command$SmartcutsMacros.stringifyRecordingCommand(sideEffect._0.command) + (", maybeInsertAfter=" + ((function (param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                          })("None") + ")")));
      case /* NotifyBgAboutPossibleCommand */2 :
          var maybeBoundingRect = sideEffect._1;
          return "NotifyBgAboutPossibleCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + (", boundingRect=" + ((
                        maybeBoundingRect !== undefined ? JSON.stringify(Rect$SmartcutsMacros.t_encode(maybeBoundingRect)) : "None"
                      ) + ")")));
      case /* ResetDebounceTimeout */3 :
          var arg$1 = OptionUtils$SmartcutsMacros.map(sideEffect._1, (function (id) {
                  return String(id);
                }));
          return "ResetDebounceTimeout(" + (sideEffect._0 + (", " + ((function (param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                          })("None") + ")")));
      case /* RespondToBg */4 :
          return "RespondToBg(respondToBg, " + (Util$SmartcutsMacros.Result.stringify(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.stringify, sideEffect._1) + ")");
      case /* StreamCommandToBgForHighlightedElement */5 :
          return "StreamCommandToBgForHighlightedElement(element, callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(sideEffect._1) + ")");
      case /* RetrievePossibleCommandInfoAndMaybeStreamToBg */6 :
          var match = sideEffect._2;
          return "RetrievePossibleCommandInfoAndMaybeStreamToBg(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + (", RetrieveClipboardItemAsPasteInContentEditable(selection), {targetBoundingRect: " + (OptionUtils$SmartcutsMacros.stringify(Rect$SmartcutsMacros.stringify, match.targetBoundingRect) + (", timestamp: " + (match.timestamp.toString() + (", insertAfterOffset: " + (String(match.insertAfterOffset) + "})")))))));
      
    }
  }
}

function stringifyInputByDomElementRepresentation(inputByDomElement) {
  return StringUtils$SmartcutsMacros.join(", ", List.map((function (param) {
                    return "[element]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "");
                  }), Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputByDomElement.toList, inputByDomElement)));
}

function stringifyState$5(param) {
  return stringifyState$4(DOM__Event$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation, DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, param);
}

function stringifyEvent$5(param) {
  return stringifyEvent$4(DOM__Event$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation, DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, param);
}

function stringifySideEffect$5(param) {
  return stringifySideEffect$4(DOM__Event$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation, DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, param);
}

function prepareStateForSerialization$1(state) {
  return mapState$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, state);
}

function prepareEventForSerialization$1($$event) {
  return mapEvent$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, $$event);
}

function prepareSideEffectForSerialization$1(sideEffect) {
  return mapSideEffect$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, sideEffect);
}

function prepareFailureForSerialization(failure) {
  return mapFailure$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, failure);
}

function prepareExitReasonForSerialization(exitReason) {
  return mapExitReason$2(DOM__Event__ForSerialization$SmartcutsMacros.make, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, exitReason);
}

function stringifyInputByDomElementRepresentation$1(inputBySelector) {
  return StringUtils$SmartcutsMacros.join(", ", List.map((function (param) {
                    return "[" + (Selector$SmartcutsMacros.stringify(undefined, false, param[0]) + ("]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "")));
                  }), Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.toList, inputBySelector)));
}

var stringifyDomHtmlElement$1 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;

var stringifyDomNode$1 = DOM__Node$SmartcutsMacros.ForSerialization.stringify;

function stringifyState$6(param) {
  return stringifyState$4(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$1, stringifyDomHtmlElement$1, stringifyDomNode$1, param);
}

function stringifyEvent$6(param) {
  return stringifyEvent$4(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$1, stringifyDomHtmlElement$1, stringifyDomNode$1, param);
}

function stringifySideEffect$6(param) {
  return stringifySideEffect$4(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$1, stringifyDomHtmlElement$1, stringifyDomNode$1, param);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "stringifyFailure"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareFailureForSerialization"
              ],
              [
                /* Function */0,
                "prepareExitReasonForSerialization"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    }, ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers, {
      Generic: {
        mapListener: mapListener$1,
        mapState: mapState$2,
        mapEvent: mapEvent$2,
        mapFailure: mapFailure$2,
        mapExitReason: mapExitReason$2,
        mapSideEffect: mapSideEffect$2,
        stringifyListener: stringifyListener$3,
        stringifyState: stringifyState$4,
        stringifyExitReason: stringifyExitReason$2,
        stringifyFailure: stringifyFailure$2,
        stringifyEvent: stringifyEvent$4,
        stringifySideEffect: stringifySideEffect$4
      },
      Regular: {
        stringifyState: stringifyState$5,
        stringifyEvent: stringifyEvent$5,
        stringifySideEffect: stringifySideEffect$5
      },
      ForSerialization: {
        stringifyState: stringifyState$6,
        stringifyEvent: stringifyEvent$6,
        stringifySideEffect: stringifySideEffect$6,
        prepareStateForSerialization: prepareStateForSerialization$1,
        prepareEventForSerialization: prepareEventForSerialization$1,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$1,
        prepareFailureForSerialization: prepareFailureForSerialization,
        prepareExitReasonForSerialization: prepareExitReasonForSerialization
      }
    });

function stringifyState$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, state) {
  if (typeof state === "number") {
    return "Init";
  }
  switch (state.TAG | 0) {
    case /* EditingGoogleSheets */0 :
        var match = state._0;
        var editingInCell = match.editingInCell;
        var cellLoc = editingInCell !== undefined ? editingInCell : "None";
        var arg = OptionUtils$SmartcutsMacros.map(match.pendingCommandKey, PendingCommandInfo$SmartcutsMacros.keyAsString);
        return "EditingGoogleSheets({ spreadsheetId: " + (match.spreadsheetId + (", sheets({len: " + (String(match.sheets.length) + ("}), editingInCell: " + (cellLoc + (", expectPaste=" + (OptionUtils$SmartcutsMacros.withDefault("None", match.expectPaste) + (", expectCellValue=" + (OptionUtils$SmartcutsMacros.withDefault("None", match.expectCellValue) + (", pendingCommandKey=" + ((function (param) {
                                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                        })("None") + (", numPendingRequests: " + (String(match.numPendingRequests) + (", sheetUpdateTriggerCount=" + (String(match.sheetUpdateTriggerCount) + (", mostRecentTriggerThatReceivedSheetUpdate=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.mostRecentTriggerThatReceivedSheetUpdate, (function (prim) {
                                                            return String(prim);
                                                          }))) + (", removeListenersPreventingUserInteraction=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.removeListenersPreventingUserInteraction, (function (param) {
                                                                return "fn";
                                                              }))) + (", googleAuthCallback=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.googleAuthCallback, (function (param) {
                                                                    return "fn";
                                                                  }))) + (", disconnectMutationObserver=" + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(match.disconnectMutationObserver, (function (param) {
                                                                        return "fn";
                                                                      }))) + ")")))))))))))))))))))))));
    case /* AwaitingPendingRequestsToFinishAndExit */1 :
        var match$1 = state._0;
        var editingInCell$1 = match$1.editingInCell;
        var cellLoc$1 = editingInCell$1 !== undefined ? editingInCell$1 : "None";
        return "AwaitingPendingRequestsToFinishAndExit({ spreadsheetId: " + (match$1.spreadsheetId + (", editingInCell: " + (cellLoc$1 + (", numPendingRequests: " + (String(match$1.numPendingRequests) + (", allExitReasons=" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                                    return stringifyExitReason$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
                                  }), state._1) + ")")))))));
    case /* Exiting */2 :
        return "Exiting({allExitReasons: " + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                        return stringifyExitReason$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
                      }), state._0.allExitReasons) + "})");
    case /* Exited */3 :
        return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                        return stringifyExitReason$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
                      }), state._0) + ")");
    
  }
}

function stringifyEvent$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event) {
  if (typeof $$event === "number") {
    if ($$event === /* Initialize */0) {
      return "Initialize";
    } else {
      return "DiscoveredGapiNotLoaded";
    }
  }
  switch ($$event.TAG | 0) {
    case /* SharedEvent */0 :
        return "SharedEvent(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement, stringifyDomEvent, $$event._0) + ")");
    case /* BasicEventOnGoogleSheets */1 :
        return "BasicEventOnGoogleSheets(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
    case /* DidPreventUserInteraction */2 :
        return "DidPreventUserInteraction(removeListeners)";
    case /* DidAttachMutationObserver */3 :
        return "DidAttachMutationObserver(disconnectMutatioObserver)";
    case /* MutationsObserved */4 :
        return "MutationsObserved([" + ($$Array.map(stringifyDomMutationRecord, $$event._0).join(", ") + "])");
    case /* DidStartListeningToCanvas */5 :
        return "DidStartListeningToCanvas(stopListening)";
    case /* CanvasDidFillText */6 :
        return "CanvasDidFillText(text, x, y, canvas)";
    case /* DiscoveredGoogleAuthMissing */7 :
        return "DiscoveredGoogleAuthMissing(" + (stringifyGoogleAuthCallback(stringifyDomEvent, $$event._0) + ")");
    case /* DidGetNewAuthToken */8 :
        return "DidGetNewAuthToken(authToken)";
    case /* DidFetchGoogleSheet */9 :
        return "DidFetchGoogleSheet(sheets)";
    case /* GoogleSheetUpdate */10 :
        return "GoogleSheetUpdate(sheets, " + (stringifyReasonToCheckUpdate(stringifyDomEvent, $$event._1) + (", pendingCommandKey=" + (PendingCommandInfo$SmartcutsMacros.keyAsString($$event._2) + (", attemptCount=" + (String($$event._3) + (", triggerIndex=" + (String($$event._4) + ")")))))));
    case /* Fail */11 :
        return "Fail(" + (stringifyFailure$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event._0) + ")");
    case /* Exit */12 :
        return "Exit(" + (stringifyExitReason$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event._0) + ")");
    
  }
}

function stringifySideEffect$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* PreventUserInteraction */0 :
          return "PreventUserInteraction";
      case /* StartGoogleAuthFlow */1 :
          return "StartGoogleAuthFlow";
      case /* StartListeningToCanvas */2 :
          return "StartListeningToCanvas";
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return "Dispatch(" + (stringifyEvent$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, sideEffect._0) + ")");
      case /* AllowUserInteraction */1 :
          return "AllowUserInteraction(removeListeners)";
      case /* FetchGoogleSheetData */2 :
          return "FetchGoogleSheetData(spreadsheetId=" + (sideEffect._0 + (", authToken=" + ((
                        sideEffect._1 !== undefined ? "<...>" : "undefined"
                      ) + ")")));
      case /* SetupMutationObserver */3 :
          return "SetupMutationObserver(" + (Curry._1(stringifyDomHtmlElement, sideEffect._0) + ")");
      case /* NotifyBgAboutPossibleCommand */4 :
          var maybeBoundingRect = sideEffect._1;
          return "NotifyBgAboutPossibleCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + (", boundingRect=" + ((
                        maybeBoundingRect !== undefined ? JSON.stringify(Rect$SmartcutsMacros.t_encode(maybeBoundingRect)) : "None"
                      ) + ")")));
      case /* CheckForGoogleSheetUpdates */5 :
          return "CheckForGoogleSheetUpdates(" + (sideEffect._0 + (", reason=" + (stringifyReasonToCheckUpdate(stringifyDomEvent, sideEffect._1) + (", authToken=" + ((
                            sideEffect._2 !== undefined ? "<...>" : "undefined"
                          ) + (", pendingCommandKey=" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._3) + (", attemptCount=" + (String(sideEffect._4) + (", triggerIndex=" + (String(sideEffect._5) + ")")))))))))));
      case /* StreamGoogleSheetsCommandsToBg */6 :
          var match = sideEffect._2;
          var arg = OptionUtils$SmartcutsMacros.map(sideEffect._1.targetBoundingRect, Rect$SmartcutsMacros.stringify);
          return "StreamGoogleSheetsCommandsToBg(commands=[" + ($$String.concat(", ", List.map(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.stringify, sideEffect._0)) + ("], {" + ((function (param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                          })("None") + ("}, (" + (PendingCommandInfo$SmartcutsMacros.keyAsString(match[0]) + (", " + (String(match[1]) + "))")))))));
      case /* TellBgThatKeyDoesNotGenerateCommand */7 :
          return "TellBgThatKeyDoesNotGenerateCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(sideEffect._0) + ")");
      case /* DisconnectMutationObserver */8 :
          return "DisconnectMutationObserver(disconnect)";
      case /* StopListeningToCanvas */9 :
          return "StopListeningToCanvas(stopListening)";
      
    }
  }
}

function stringifyGoogleAuthCallback(stringifyDomEvent, cb) {
  if (cb.TAG === /* Cb_FetchGoogleSheetData */0) {
    return "Cb_FetchGoogleSheetData(" + (cb._0 + ")");
  } else {
    return "Cb_CheckForGoogleSheetUpdates(" + (cb._0 + (", " + (stringifyReasonToCheckUpdate(stringifyDomEvent, cb._1) + (", pendingCommandKey=" + (PendingCommandInfo$SmartcutsMacros.keyAsString(cb._2) + (", attemptCount=" + (String(cb._3) + ")")))))));
  }
}

function stringifyReasonToCheckUpdate(stringifyDomEvent, reason) {
  if (typeof reason === "number") {
    return "EditingCellChanged";
  }
  switch (reason.TAG | 0) {
    case /* PastedText */0 :
        return "PastedText(" + (reason._0 + ")");
    case /* PasteEvent */1 :
        return "PasteEvent(" + (Curry._1(stringifyDomEvent, reason._0) + ")");
    case /* ChangeEvent */2 :
        return "ChangeEvent(" + (StringUtils$SmartcutsMacros.quote(reason._0) + ")");
    
  }
}

function stringifyListener$4(stringifyDomMutationRecord, listener) {
  if (listener) {
    return "GoogleSheetsMutationObserverListener([" + ($$Array.map(stringifyDomMutationRecord, listener._0).join(", ") + "])");
  } else {
    return "CanvasListener";
  }
}

function stringifyFailure$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, failure) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, (function (param) {
                return stringifyState$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyEvent$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifySideEffect$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyListener$4(stringifyDomMutationRecord, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, failure);
}

function stringifyExitReason$3(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, exitReason) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, (function (param) {
                return stringifyState$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyEvent$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifySideEffect$7(stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param);
              }), (function (param) {
                return stringifyListener$4(stringifyDomMutationRecord, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}

function mapState$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, state) {
  if (typeof state === "number") {
    return /* Init */0;
  }
  switch (state.TAG | 0) {
    case /* EditingGoogleSheets */0 :
        return {
                TAG: /* EditingGoogleSheets */0,
                _0: mapEditingState(mapDomEvent, state._0)
              };
    case /* AwaitingPendingRequestsToFinishAndExit */1 :
        return {
                TAG: /* AwaitingPendingRequestsToFinishAndExit */1,
                _0: mapEditingState(mapDomEvent, state._0),
                _1: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                        return mapExitReason$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
                      }), state._1)
              };
    case /* Exiting */2 :
        return {
                TAG: /* Exiting */2,
                _0: {
                  allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                          return mapExitReason$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
                        }), state._0.allExitReasons)
                }
              };
    case /* Exited */3 :
        return {
                TAG: /* Exited */3,
                _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                        return mapExitReason$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
                      }), state._0)
              };
    
  }
}

function mapEvent$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event) {
  if (typeof $$event === "number") {
    if ($$event === /* Initialize */0) {
      return /* Initialize */0;
    } else {
      return /* DiscoveredGapiNotLoaded */1;
    }
  }
  switch ($$event.TAG | 0) {
    case /* SharedEvent */0 :
        return {
                TAG: /* SharedEvent */0,
                _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement, mapDomEvent, $$event._0)
              };
    case /* BasicEventOnGoogleSheets */1 :
        return {
                TAG: /* BasicEventOnGoogleSheets */1,
                _0: $$event._0
              };
    case /* DidPreventUserInteraction */2 :
        return {
                TAG: /* DidPreventUserInteraction */2,
                _0: $$event._0
              };
    case /* DidAttachMutationObserver */3 :
        return {
                TAG: /* DidAttachMutationObserver */3,
                _0: $$event._0
              };
    case /* MutationsObserved */4 :
        return {
                TAG: /* MutationsObserved */4,
                _0: $$Array.map(mapDomMutationRecord, $$event._0)
              };
    case /* DidStartListeningToCanvas */5 :
        return {
                TAG: /* DidStartListeningToCanvas */5,
                _0: $$event._0
              };
    case /* CanvasDidFillText */6 :
        return {
                TAG: /* CanvasDidFillText */6,
                _0: $$event._0,
                _1: $$event._1,
                _2: $$event._2,
                _3: Curry._1(mapDomHtmlElement, $$event._3)
              };
    case /* DiscoveredGoogleAuthMissing */7 :
        return {
                TAG: /* DiscoveredGoogleAuthMissing */7,
                _0: mapGoogleAuthCallback(mapDomEvent, $$event._0)
              };
    case /* DidGetNewAuthToken */8 :
        return {
                TAG: /* DidGetNewAuthToken */8,
                _0: $$event._0
              };
    case /* DidFetchGoogleSheet */9 :
        return {
                TAG: /* DidFetchGoogleSheet */9,
                _0: $$event._0
              };
    case /* GoogleSheetUpdate */10 :
        return {
                TAG: /* GoogleSheetUpdate */10,
                _0: $$event._0,
                _1: mapReasonToCheckUpdate(mapDomEvent, $$event._1),
                _2: $$event._2,
                _3: $$event._3,
                _4: $$event._4
              };
    case /* Fail */11 :
        return {
                TAG: /* Fail */11,
                _0: mapFailure$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    case /* Exit */12 :
        return {
                TAG: /* Exit */12,
                _0: mapExitReason$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    
  }
}

function mapSideEffect$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* PreventUserInteraction */0 :
          return /* PreventUserInteraction */0;
      case /* StartGoogleAuthFlow */1 :
          return /* StartGoogleAuthFlow */1;
      case /* StartListeningToCanvas */2 :
          return /* StartListeningToCanvas */2;
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return {
                  TAG: /* Dispatch */0,
                  _0: mapEvent$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, sideEffect._0)
                };
      case /* AllowUserInteraction */1 :
          return {
                  TAG: /* AllowUserInteraction */1,
                  _0: sideEffect._0
                };
      case /* FetchGoogleSheetData */2 :
          return {
                  TAG: /* FetchGoogleSheetData */2,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* SetupMutationObserver */3 :
          return {
                  TAG: /* SetupMutationObserver */3,
                  _0: Curry._1(mapDomHtmlElement, sideEffect._0)
                };
      case /* NotifyBgAboutPossibleCommand */4 :
          return {
                  TAG: /* NotifyBgAboutPossibleCommand */4,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* CheckForGoogleSheetUpdates */5 :
          return {
                  TAG: /* CheckForGoogleSheetUpdates */5,
                  _0: sideEffect._0,
                  _1: mapReasonToCheckUpdate(mapDomEvent, sideEffect._1),
                  _2: sideEffect._2,
                  _3: sideEffect._3,
                  _4: sideEffect._4,
                  _5: sideEffect._5
                };
      case /* StreamGoogleSheetsCommandsToBg */6 :
          return {
                  TAG: /* StreamGoogleSheetsCommandsToBg */6,
                  _0: sideEffect._0,
                  _1: sideEffect._1,
                  _2: sideEffect._2
                };
      case /* TellBgThatKeyDoesNotGenerateCommand */7 :
          return {
                  TAG: /* TellBgThatKeyDoesNotGenerateCommand */7,
                  _0: sideEffect._0
                };
      case /* DisconnectMutationObserver */8 :
          return {
                  TAG: /* DisconnectMutationObserver */8,
                  _0: sideEffect._0
                };
      case /* StopListeningToCanvas */9 :
          return {
                  TAG: /* StopListeningToCanvas */9,
                  _0: sideEffect._0
                };
      
    }
  }
}

function mapEditingState(mapDomEvent, editingState) {
  return {
          spreadsheetId: editingState.spreadsheetId,
          sheets: editingState.sheets,
          editingInCell: editingState.editingInCell,
          numPendingRequests: editingState.numPendingRequests,
          disconnectMutationObserver: editingState.disconnectMutationObserver,
          stopListeningToCanvas: editingState.stopListeningToCanvas,
          expectPaste: editingState.expectPaste,
          googleAuthCallback: OptionUtils$SmartcutsMacros.map(editingState.googleAuthCallback, (function (param) {
                  return mapGoogleAuthCallback(mapDomEvent, param);
                })),
          removeListenersPreventingUserInteraction: editingState.removeListenersPreventingUserInteraction,
          sheetUpdateTriggerCount: editingState.sheetUpdateTriggerCount,
          mostRecentTriggerThatReceivedSheetUpdate: editingState.mostRecentTriggerThatReceivedSheetUpdate,
          rectForCommandKey: editingState.rectForCommandKey,
          expectCellValue: editingState.expectCellValue,
          pendingCommandKey: editingState.pendingCommandKey
        };
}

function mapGoogleAuthCallback(mapDomEvent, cb) {
  if (cb.TAG === /* Cb_FetchGoogleSheetData */0) {
    return {
            TAG: /* Cb_FetchGoogleSheetData */0,
            _0: cb._0
          };
  } else {
    return {
            TAG: /* Cb_CheckForGoogleSheetUpdates */1,
            _0: cb._0,
            _1: mapReasonToCheckUpdate(mapDomEvent, cb._1),
            _2: cb._2,
            _3: cb._3
          };
  }
}

function mapReasonToCheckUpdate(mapDomEvent, reason) {
  if (typeof reason === "number") {
    return /* EditingCellChanged */0;
  }
  switch (reason.TAG | 0) {
    case /* PastedText */0 :
        return {
                TAG: /* PastedText */0,
                _0: reason._0
              };
    case /* PasteEvent */1 :
        return {
                TAG: /* PasteEvent */1,
                _0: Curry._1(mapDomEvent, reason._0)
              };
    case /* ChangeEvent */2 :
        return {
                TAG: /* ChangeEvent */2,
                _0: reason._0
              };
    
  }
}

function mapListener$2(mapDomMutationRecord, listener) {
  if (listener) {
    return /* GoogleSheetsMutationObserverListener */{
            _0: $$Array.map(mapDomMutationRecord, listener._0)
          };
  } else {
    return /* CanvasListener */0;
  }
}

function mapFailure$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, (function (param) {
                return mapState$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapEvent$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapListener$2(mapDomMutationRecord, param);
              }), failure);
}

function mapExitReason$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, exitReason) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, (function (param) {
                return mapState$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapEvent$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect$3(mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param);
              }), (function (param) {
                return mapListener$2(mapDomMutationRecord, param);
              }), exitReason);
}

var stringifyDomMutationRecord$2 = DOM$SmartcutsMacros.$$MutationRecord.stringify;

function stringifyState$8(param) {
  return stringifyState$7(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$2, DOM__Event$SmartcutsMacros.stringify, param);
}

function stringifyEvent$8(param) {
  return stringifyEvent$7(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$2, DOM__Event$SmartcutsMacros.stringify, param);
}

function stringifySideEffect$8(param) {
  return stringifySideEffect$7(DOM__HtmlElement$SmartcutsMacros.stringify, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$2, DOM__Event$SmartcutsMacros.stringify, param);
}

var stringifyDomHtmlElement$2 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;

var stringifyDomNode$2 = DOM__Node$SmartcutsMacros.ForSerialization.stringify;

var stringifyDomMutationRecord$3 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify;

function stringifyState$9(param) {
  return stringifyState$7(stringifyDomHtmlElement$2, stringifyDomNode$2, stringifyDomMutationRecord$3, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}

function stringifyEvent$9(param) {
  return stringifyEvent$7(stringifyDomHtmlElement$2, stringifyDomNode$2, stringifyDomMutationRecord$3, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}

function stringifySideEffect$9(param) {
  return stringifySideEffect$7(stringifyDomHtmlElement$2, stringifyDomNode$2, stringifyDomMutationRecord$3, DOM__Event__ForSerialization$SmartcutsMacros.stringify, param);
}

var mapDomHtmlElement$1 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement;

var mapDomNode$1 = DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode;

var mapDomMutationRecord$1 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord;

var mapDomEvent$1 = DOM__Event__ForSerialization$SmartcutsMacros.make;

function prepareStateForSerialization$2(state) {
  return mapState$3(mapDomHtmlElement$1, mapDomNode$1, mapDomMutationRecord$1, mapDomEvent$1, state);
}

function prepareEventForSerialization$2($$event) {
  return mapEvent$3(mapDomHtmlElement$1, mapDomNode$1, mapDomMutationRecord$1, mapDomEvent$1, $$event);
}

function prepareSideEffectForSerialization$2(sideEffect) {
  return mapSideEffect$3(mapDomHtmlElement$1, mapDomNode$1, mapDomMutationRecord$1, mapDomEvent$1, sideEffect);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyFailure"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    }, ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers, {
      Generic: {
        stringifyState: stringifyState$7,
        stringifyEvent: stringifyEvent$7,
        stringifyListener: stringifyListener$4,
        stringifySideEffect: stringifySideEffect$7,
        stringifyFailure: stringifyFailure$3,
        stringifyExitReason: stringifyExitReason$3,
        mapState: mapState$3,
        mapEvent: mapEvent$3,
        mapSideEffect: mapSideEffect$3,
        mapListener: mapListener$2,
        mapFailure: mapFailure$3,
        mapExitReason: mapExitReason$3
      },
      Regular: {
        stringifyState: stringifyState$8,
        stringifyEvent: stringifyEvent$8,
        stringifySideEffect: stringifySideEffect$8
      },
      ForSerialization: {
        stringifyState: stringifyState$9,
        stringifyEvent: stringifyEvent$9,
        stringifySideEffect: stringifySideEffect$9,
        prepareStateForSerialization: prepareStateForSerialization$2,
        prepareEventForSerialization: prepareEventForSerialization$2,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$2
      }
    });

function stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param) {
  return "{eventStreaming: " + (Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifyState, stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, param.eventStreaming) + (", contentEditing: " + (Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifyState, stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param.contentEditing) + (", googleSheets: " + (Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifyState, stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, param.googleSheets) + "}")))));
}

function stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord, listener) {
  if (typeof listener === "number") {
    return "NoListener";
  }
  switch (listener.TAG | 0) {
    case /* EventStreamingListener */0 :
        return "EventStreamingListener(" + (Curry._2(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifyListener, stringifyDomEvent, listener._0) + ")");
    case /* ContentEditingListener */1 :
        return "ContentEditingListener(" + (Curry._2(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifyListener, stringifyDomMutationRecord, listener._0) + ")");
    case /* GoogleSheetsListener */2 :
        return "GoogleSheetsListener(" + (Curry._2(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifyListener, stringifyDomMutationRecord, listener._0) + ")");
    
  }
}

function stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, state) {
  switch (state.TAG | 0) {
    case /* Init */0 :
        return "Init(" + (stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, state._0) + ")");
    case /* Parallel */1 :
        return "Parallel(" + (stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, state._0) + ")");
    case /* Exiting */2 :
        var match = state._0;
        return "Exiting({parallelStates: " + (stringifyParallelState(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, match.parallelStates) + (", maybeChildrenExitingHelperState, , allExitReasons:" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                            return stringifyExitReason$4(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                          }), match.allExitReasons) + "})")));
    
  }
}

function stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, $$event) {
  switch ($$event.TAG | 0) {
    case /* Initialize */0 :
        if ($$event._0 !== undefined) {
          return "Initialize(respondToBg, rejectToBg)";
        } else {
          return "Initialize(None)";
        }
    case /* SharedEvent */1 :
        return "Shared(" + (ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.stringifyEvent(stringifyDomHtmlElement, stringifyDomEvent, $$event._0) + ")");
    case /* BasicEventWhileRecording */2 :
        return "BasicEventWhileRecording(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
    case /* EventStreamingEvent */3 :
        return "EventStreamingEvent(" + (Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifyEvent, stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode, $$event._0) + ")");
    case /* ContentEditingEvent */4 :
        return "ContentEditingEvent(" + (Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifyEvent, stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event._0) + ")");
    case /* GoogleSheetsEvent */5 :
        return "GoogleSheetsEvent(" + (Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifyEvent, stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent, $$event._0) + ")");
    case /* Fail */6 :
        return "Fail(" + (Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, (function (param) {
                        return stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                      }), (function (param) {
                        return stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                      }), (function (param) {
                        return stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                      }), (function (param) {
                        return stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord, param);
                      }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._0) + ")");
    case /* Exit */7 :
        return "Exit(" + (Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, (function (param) {
                        return stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                      }), (function (param) {
                        return stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                      }), (function (param) {
                        return stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
                      }), (function (param) {
                        return stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord, param);
                      }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._0) + ")");
    
  }
}

function stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, sideEffect) {
  switch (sideEffect.TAG | 0) {
    case /* Dispatch */0 :
        return "Dispatch(" + (stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, sideEffect._0) + ")");
    case /* EventStreamingSideEffect */1 :
        return "EventStreamingSideEffect(" + (SideEffectGroup$SmartcutsMacros.List.stringify(Curry._4(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.stringifySideEffect, stringifyDomEvent, stringifyInputByDomElementRepresentation, stringifyDomHtmlElement, stringifyDomNode), sideEffect._0) + ")");
    case /* ContentEditingSideEffect */2 :
        return "ContentEditingSideEffect" + (SideEffectGroup$SmartcutsMacros.List.stringify(Curry._4(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.stringifySideEffect, stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent), sideEffect._0) + ")");
    case /* GoogleSheetsSideEffect */3 :
        return "GoogleSheetsSideEffect" + (SideEffectGroup$SmartcutsMacros.List.stringify(Curry._4(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.stringifySideEffect, stringifyDomHtmlElement, stringifyDomNode, stringifyDomMutationRecord, stringifyDomEvent), sideEffect._0) + ")");
    case /* RespondToBg */4 :
        return "RespondToBg(respondToBg, " + (Util$SmartcutsMacros.Result.stringify(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.stringify, sideEffect._1) + ")");
    
  }
}

function stringifyExitReason$4(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, exitReason) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, (function (param) {
                return stringifyState$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
              }), (function (param) {
                return stringifyEvent$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
              }), (function (param) {
                return stringifySideEffect$10(stringifyDomEvent, stringifyDomHtmlElement, stringifyInputByDomElementRepresentation, stringifyDomNode, stringifyDomMutationRecord, param);
              }), (function (param) {
                return stringifyListener$5(stringifyDomEvent, stringifyDomMutationRecord, param);
              }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, exitReason);
}

function mapParallelState(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param) {
  return {
          eventStreaming: Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapState, mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, param.eventStreaming),
          contentEditing: Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapState, mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param.contentEditing),
          googleSheets: Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapState, mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, param.googleSheets)
        };
}

function mapListener$3(mapDomEvent, mapDomMutationRecord, listener) {
  if (typeof listener === "number") {
    return /* NoListener */0;
  }
  switch (listener.TAG | 0) {
    case /* EventStreamingListener */0 :
        return {
                TAG: /* EventStreamingListener */0,
                _0: Curry._2(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapListener, mapDomEvent, listener._0)
              };
    case /* ContentEditingListener */1 :
        return {
                TAG: /* ContentEditingListener */1,
                _0: Curry._2(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapListener, mapDomMutationRecord, listener._0)
              };
    case /* GoogleSheetsListener */2 :
        return {
                TAG: /* GoogleSheetsListener */2,
                _0: Curry._2(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapListener, mapDomMutationRecord, listener._0)
              };
    
  }
}

function mapState$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, state) {
  switch (state.TAG | 0) {
    case /* Init */0 :
        return {
                TAG: /* Init */0,
                _0: mapParallelState(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, state._0)
              };
    case /* Parallel */1 :
        return {
                TAG: /* Parallel */1,
                _0: mapParallelState(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, state._0)
              };
    case /* Exiting */2 :
        var match = state._0;
        return {
                TAG: /* Exiting */2,
                _0: {
                  parallelStates: mapParallelState(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, match.parallelStates),
                  maybeRespondToBgWithResult: match.maybeRespondToBgWithResult,
                  allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                          return mapExitReason$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
                        }), match.allExitReasons)
                }
              };
    
  }
}

function mapEvent$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, $$event) {
  switch ($$event.TAG | 0) {
    case /* Initialize */0 :
        return {
                TAG: /* Initialize */0,
                _0: $$event._0
              };
    case /* SharedEvent */1 :
        return {
                TAG: /* SharedEvent */1,
                _0: ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.mapEvent(mapDomHtmlElement, mapDomEvent, $$event._0)
              };
    case /* BasicEventWhileRecording */2 :
        return {
                TAG: /* BasicEventWhileRecording */2,
                _0: $$event._0
              };
    case /* EventStreamingEvent */3 :
        return {
                TAG: /* EventStreamingEvent */3,
                _0: Curry._5(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapEvent, mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode, $$event._0)
              };
    case /* ContentEditingEvent */4 :
        return {
                TAG: /* ContentEditingEvent */4,
                _0: Curry._5(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapEvent, mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    case /* GoogleSheetsEvent */5 :
        return {
                TAG: /* GoogleSheetsEvent */5,
                _0: Curry._5(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapEvent, mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    case /* Fail */6 :
        return {
                TAG: /* Fail */6,
                _0: mapFailure$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, $$event._0)
              };
    case /* Exit */7 :
        return {
                TAG: /* Exit */7,
                _0: mapExitReason$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, $$event._0)
              };
    
  }
}

function mapFailure$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, (function (param) {
                return mapState$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
              }), (function (param) {
                return mapEvent$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
              }), (function (param) {
                return mapSideEffect$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
              }), (function (param) {
                return mapListener$3(mapDomEvent, mapDomMutationRecord, param);
              }), failure);
}

function mapExitReason$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, exitReason) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, (function (param) {
                return mapState$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
              }), (function (param) {
                return mapEvent$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
              }), (function (param) {
                return mapSideEffect$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, param);
              }), (function (param) {
                return mapListener$3(mapDomEvent, mapDomMutationRecord, param);
              }), exitReason);
}

function mapSideEffect$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, sideEffect) {
  switch (sideEffect.TAG | 0) {
    case /* Dispatch */0 :
        return {
                TAG: /* Dispatch */0,
                _0: mapEvent$4(mapDomEvent, mapDomHtmlElement, mapInputByDomElementRepresentation, mapDomNode, mapDomMutationRecord, sideEffect._0)
              };
    case /* EventStreamingSideEffect */1 :
        return {
                TAG: /* EventStreamingSideEffect */1,
                _0: SideEffectGroup$SmartcutsMacros.List.map(Curry._4(ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers.Generic.mapSideEffect, mapDomEvent, mapInputByDomElementRepresentation, mapDomHtmlElement, mapDomNode), sideEffect._0)
              };
    case /* ContentEditingSideEffect */2 :
        return {
                TAG: /* ContentEditingSideEffect */2,
                _0: SideEffectGroup$SmartcutsMacros.List.map(Curry._4(ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers.Generic.mapSideEffect, mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent), sideEffect._0)
              };
    case /* GoogleSheetsSideEffect */3 :
        return {
                TAG: /* GoogleSheetsSideEffect */3,
                _0: SideEffectGroup$SmartcutsMacros.List.map(Curry._4(ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers.Generic.mapSideEffect, mapDomHtmlElement, mapDomNode, mapDomMutationRecord, mapDomEvent), sideEffect._0)
              };
    case /* RespondToBg */4 :
        return {
                TAG: /* RespondToBg */4,
                _0: sideEffect._0,
                _1: sideEffect._1
              };
    
  }
}

function stringifyInputByDomElementRepresentation$2(inputByDomElement) {
  return StringUtils$SmartcutsMacros.join(", ", List.map((function (param) {
                    return "[element]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "");
                  }), Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputByDomElement.toList, inputByDomElement)));
}

var stringifyDomMutationRecord$4 = DOM$SmartcutsMacros.$$MutationRecord.stringify;

function stringifyState$11(param) {
  return stringifyState$10(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}

function stringifyEvent$11(param) {
  return stringifyEvent$10(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}

function stringifySideEffect$11(param) {
  return stringifySideEffect$10(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}

function stringifyExitReason$5(param) {
  return stringifyExitReason$4(DOM__Event$SmartcutsMacros.stringify, DOM__HtmlElement$SmartcutsMacros.stringify, stringifyInputByDomElementRepresentation$2, DOM__Node$SmartcutsMacros.stringify, stringifyDomMutationRecord$4, param);
}

function prepareStateForSerialization$3(state) {
  return mapState$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, state);
}

function prepareEventForSerialization$3($$event) {
  return mapEvent$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, $$event);
}

function prepareSideEffectForSerialization$3(sideEffect) {
  return mapSideEffect$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, sideEffect);
}

function prepareExitReasonForSerialization$1(exitReason) {
  return mapExitReason$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.fromInputByDomElement, DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, exitReason);
}

var stringifyDomHtmlElement$3 = DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify;

function stringifyInputByDomElementRepresentation$3(inputBySelector) {
  return StringUtils$SmartcutsMacros.join(", ", List.map((function (param) {
                    return "[" + (Selector$SmartcutsMacros.stringify(undefined, false, param[0]) + ("]=" + (Virtualized__Input$SmartcutsMacros.stringify(param[1]) + "")));
                  }), Curry._1(Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.toList, inputBySelector)));
}

var stringifyDomNode$3 = DOM__Node$SmartcutsMacros.ForSerialization.stringify;

var stringifyDomMutationRecord$5 = DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify;

function stringifyState$12(param) {
  return stringifyState$10(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyDomHtmlElement$3, stringifyInputByDomElementRepresentation$3, stringifyDomNode$3, stringifyDomMutationRecord$5, param);
}

function stringifyEvent$12(param) {
  return stringifyEvent$10(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyDomHtmlElement$3, stringifyInputByDomElementRepresentation$3, stringifyDomNode$3, stringifyDomMutationRecord$5, param);
}

function stringifySideEffect$12(param) {
  return stringifySideEffect$10(DOM__Event__ForSerialization$SmartcutsMacros.stringify, stringifyDomHtmlElement$3, stringifyInputByDomElementRepresentation$3, stringifyDomNode$3, stringifyDomMutationRecord$5, param);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyParallelState"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapExitReason"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyExitReason"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareExitReasonForSerialization"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    }, ContentScript__StateMachine__RecordingMode__Types__Helpers, {
      Generic: {
        stringifyParallelState: stringifyParallelState,
        stringifyState: stringifyState$10,
        stringifyListener: stringifyListener$5,
        stringifyEvent: stringifyEvent$10,
        stringifySideEffect: stringifySideEffect$10,
        stringifyExitReason: stringifyExitReason$4,
        mapState: mapState$4,
        mapListener: mapListener$3,
        mapEvent: mapEvent$4,
        mapFailure: mapFailure$4,
        mapExitReason: mapExitReason$4,
        mapSideEffect: mapSideEffect$4
      },
      Regular: {
        stringifyState: stringifyState$11,
        stringifyEvent: stringifyEvent$11,
        stringifySideEffect: stringifySideEffect$11,
        stringifyExitReason: stringifyExitReason$5
      },
      ForSerialization: {
        prepareStateForSerialization: prepareStateForSerialization$3,
        prepareEventForSerialization: prepareEventForSerialization$3,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$3,
        prepareExitReasonForSerialization: prepareExitReasonForSerialization$1,
        stringifyState: stringifyState$12,
        stringifyEvent: stringifyEvent$12,
        stringifySideEffect: stringifySideEffect$12
      }
    });

function stringifyEvent$13($$event) {
  if ($$event.TAG === /* MessageFromExtension */0) {
    return "MessageFromExtension(" + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyMessage, $$event._0) + ", respondToBg, rejectToBg)");
  } else {
    return "DidGetNewAuthToken(" + ($$event._0 + ")");
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          /* Function */0,
          "stringifyEvent"
        ]]
    }, ContentScript__StateMachine__Shared__Types__Helpers, {
      stringifyEvent: stringifyEvent$13
    });

function stringifyState$13(stringifyHtmlElement, stringifyDomEvent, stringifyRecordingState, state) {
  if (typeof state === "number") {
    if (state === /* Init */0) {
      return "Init";
    } else {
      return "ExtensionContextInvalidated";
    }
  }
  switch (state.TAG | 0) {
    case /* WaitingForBgToAckContentScriptReady */0 :
        return "WaitingForBgToAckContentScriptReady(contentScriptIdle)";
    case /* ContentScriptIdle */1 :
        var arg = OptionUtils$SmartcutsMacros.map(state._0.disconnectLinkTriggerListener, (function (param) {
                return "Some";
              }));
        return "ContentScriptIdle({disconnectLinkTriggerListener: " + ((function (param) {
                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                    })("None") + "})");
    case /* RecordingMode */2 :
        return "RecordingMode(" + (Curry._1(stringifyRecordingState, state._0) + ")");
    case /* PlaybackMode */3 :
        return "PlaybackMode(" + (Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.stringifyState, stringifyHtmlElement, stringifyDomEvent, state._0) + ")");
    case /* UrlTriggeringMode */4 :
        return "UrlTriggeringMode(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyState(stringifyHtmlElement, stringifyDomEvent, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, state._0) + ")");
    case /* DataExtractionMode */5 :
        return "DataExtractionMode(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifyState(stringifyHtmlElement, state._0) + ")");
    
  }
}

function stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, errorContext) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.stringify, (function (param) {
                return stringifyState$13(stringifyHtmlElement, stringifyDomEvent, stringifyRecordingState, param);
              }), (function (param) {
                return stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
              }), (function (param) {
                return stringifySideEffect$13(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
              }), (function (param) {
                return stringifyListener$6(stringifyDomEvent, stringifyDomMutationRecord, param);
              }), errorContext);
}

function stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, $$event) {
  if (typeof $$event === "number") {
    return "Initialize";
  }
  switch ($$event.TAG | 0) {
    case /* BasicEventRootLevel */0 :
        return "BasicEventRootLevel(" + (Curry._1(ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
    case /* BgDidAckContentScriptReady */1 :
        return "BgDidAckContentScriptReady(" + (Util$SmartcutsMacros.Result.stringify(ExtensionMessagingLogging.FromTab.ContentScriptReady.stringifyResponse, (function (str) {
                        return str;
                      }), $$event._0) + ")");
    case /* DidRespondToBgWithContentScriptFailureId */2 :
        return "DidRespondToBgWithContentScriptFailureId(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify($$event._0) + (", failWith=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._1) + (", errorContext=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, $$event._2) + ")")))));
    case /* DidSetupLinkTriggerListener */3 :
        return "DidSetupLinkTriggerListener(teardownListener)";
    case /* RecordingModeEvent */4 :
        return "RecordingModeEvent(" + (Curry._1(stringifyRecordingEvent, $$event._0) + ")");
    case /* PlaybackModeEvent */5 :
        return "PlaybackModeEvent(" + (Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.stringifyEvent, stringifyHtmlElement, stringifyDomEvent, $$event._0) + ")");
    case /* UrlTriggeringModeEvent */6 :
        return "UrlTriggeringModeEvent(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyEvent(stringifyHtmlElement, stringifyDomEvent, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, $$event._0) + ")");
    case /* DataExtractionModeEvent */7 :
        return "DataExtractionModeEvent(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifyEvent(stringifyHtmlElement, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, stringifyDomEvent, $$event._0) + ")");
    case /* Fail */8 :
        return "Fail(" + (Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, (function (param) {
                        return stringifyState$13(stringifyHtmlElement, stringifyDomEvent, stringifyRecordingState, param);
                      }), (function (param) {
                        return stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
                      }), (function (param) {
                        return stringifySideEffect$13(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, param);
                      }), (function (param) {
                        return stringifyListener$6(stringifyDomEvent, stringifyDomMutationRecord, param);
                      }), ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, $$event._0) + ")");
    case /* ContextMenuEventDidFireOnElement */9 :
        return "ContextMenuEventDidFireOnElement(htmlElement)";
    
  }
}

function stringifySideEffect$13(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* ResetStateMachineHistory */0 :
          return "ResetStateMachineHistory";
      case /* NotifyBgThatContentScriptReady */1 :
          return "NotifyBgThatContentScriptReady";
      case /* SetupLinkTriggerListener */2 :
          return "SetupLinkTriggerListener";
      case /* RemoveRenderedContent */3 :
          return "RemoveRenderedContent";
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return "Dispatch(" + (stringifyEvent$14(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._0) + ")");
      case /* NotifyBgOfContentScriptFailure */1 :
          return "NotifyBgOfContentScriptFailure(failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, sideEffect._0) + (", context=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._1) + ")")));
      case /* NotifyBgOfContentScriptResponseFailure */2 :
          return "NotifyBgOfContentScriptResponseFailure(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(sideEffect._0) + ("failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, sideEffect._1) + (", context=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._2) + ")")))));
      case /* TeardownLinkTriggerListener */3 :
          return "TeardownLinkTriggerListener(fn)";
      case /* RecordingModeSideEffect */4 :
          return "RecordingModeSideEffect(" + (Curry._1(stringifyRecordingSideEffect, sideEffect._0) + ")");
      case /* PlaybackModeSideEffect */5 :
          return "PlaybackModeSideEffect(" + (Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.stringifySideEffect, stringifyHtmlElement, stringifyDomEvent, sideEffect._0) + ")");
      case /* UrlTriggeringModeSideEffect */6 :
          return "UrlTriggeringModeSideEffect(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, sideEffect._0) + ")");
      case /* DataExtractionModeSideEffect */7 :
          return "DataExtractionModeSideEffect(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifySideEffect(stringifyHtmlElement, ContentScript__StateMachine__Shared__Types__Helpers.stringifyEvent, stringifyDomEvent, sideEffect._0) + ")");
      case /* WindowAlert */8 :
          return "WindowAlert(" + (StringUtils$SmartcutsMacros.quote(sideEffect._0) + ")");
      case /* ConsoleJsPromiseError */9 :
          return "ConsoleJsPromiseError(error, errorContext=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._1) + ")");
      case /* ConsoleJsExn */10 :
          return "ConsoleJsExn(error, errorContext=" + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._1) + ")");
      case /* RespondToBg */11 :
          return "RespondToBg(respondToBg, " + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyResponse, sideEffect._1) + ")");
      case /* RespondToBgWithFailure */12 :
          return "RespondToBgWithFailure(respondToBg, failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, sideEffect._1) + (stringifyErrorContext(stringifyHtmlElement, stringifyDomEvent, stringifyDomMutationRecord, stringifyRecordingState, stringifyRecordingEvent, stringifyRecordingSideEffect, sideEffect._2) + ")"));
      case /* RenderOnHostPage */13 :
          return "RenderOnHostPage(" + (RenderOnHost$SmartcutsMacros.stringify(sideEffect._0) + ")");
      case /* RenderHtmlMarkup */14 :
          return "RenderHtmlMarkup(" + (sideEffect._0 + ")");
      case /* UpdateRenderedContentGeometry */15 :
          return "UpdateRenderedContentGeometry(" + (RenderOnHost__Geometry$SmartcutsMacros.stringify(sideEffect._0) + ")");
      case /* CheckIfElementExistsOnPageAndRespond */16 :
          return "CheckIfElementExistsOnPageAndRespond(" + (Selector$SmartcutsMacros.stringifyElementSelector(sideEffect._0) + (", maybeInnerTextSemantic: " + (OptionUtils$SmartcutsMacros.stringify(InnerTextSemantic$SmartcutsMacros.stringify, sideEffect._1) + ", respondToBg)")));
      
    }
  }
}

function stringifyListener$6(stringifyDomEvent, stringifyDomMutationRecord, listener) {
  if (typeof listener === "number") {
    if (listener === /* NoListener */0) {
      return "NoListener";
    } else {
      return "ContextMenuDomEventListener";
    }
  }
  switch (listener.TAG | 0) {
    case /* MessageFromExtensionListener */0 :
        return "ContentScript.onMessageFromExtension(" + (Curry._1(ExtensionMessagingLogging.FromExtension.All.stringifyMessage, listener._0) + ")");
    case /* RecordingModeListener */1 :
        return "RecordingModeListener(" + (Curry._3(ContentScript__StateMachine__RecordingMode__Types__Helpers.Generic.stringifyListener, stringifyDomEvent, stringifyDomMutationRecord, listener._0) + ")");
    case /* UrlTriggeringModeListener */2 :
        return "UrlTriggeringModeListener(" + (ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.stringifyListener(listener._0) + ")");
    case /* DataExtractionModeListener */3 :
        return "DataExtractionModeListener(" + (ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.stringifyListener(listener._0) + ")");
    
  }
}

function mapListener$4(mapDomEvent, mapDomMutationRecord, listener) {
  if (typeof listener === "number") {
    if (listener === /* NoListener */0) {
      return /* NoListener */0;
    } else {
      return /* ContextMenuDomEventListener */1;
    }
  }
  switch (listener.TAG | 0) {
    case /* MessageFromExtensionListener */0 :
        return {
                TAG: /* MessageFromExtensionListener */0,
                _0: listener._0,
                _1: listener._1,
                _2: listener._2
              };
    case /* RecordingModeListener */1 :
        return {
                TAG: /* RecordingModeListener */1,
                _0: Curry._3(ContentScript__StateMachine__RecordingMode__Types__Helpers.Generic.mapListener, mapDomEvent, mapDomMutationRecord, listener._0)
              };
    case /* UrlTriggeringModeListener */2 :
        return {
                TAG: /* UrlTriggeringModeListener */2,
                _0: listener._0
              };
    case /* DataExtractionModeListener */3 :
        return {
                TAG: /* DataExtractionModeListener */3,
                _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapListener(mapDomMutationRecord, listener._0)
              };
    
  }
}

function mapContentScriptIdle(mapHtmlElement, param) {
  return {
          lastContextMenuTarget: OptionUtils$SmartcutsMacros.map(param.lastContextMenuTarget, mapHtmlElement),
          disconnectLinkTriggerListener: param.disconnectLinkTriggerListener
        };
}

function mapState$5(mapRecordingState, mapHtmlElement, mapDomEvent, state) {
  if (typeof state === "number") {
    if (state === /* Init */0) {
      return /* Init */0;
    } else {
      return /* ExtensionContextInvalidated */1;
    }
  }
  switch (state.TAG | 0) {
    case /* WaitingForBgToAckContentScriptReady */0 :
        return {
                TAG: /* WaitingForBgToAckContentScriptReady */0,
                _0: mapContentScriptIdle(mapHtmlElement, state._0)
              };
    case /* ContentScriptIdle */1 :
        return {
                TAG: /* ContentScriptIdle */1,
                _0: mapContentScriptIdle(mapHtmlElement, state._0)
              };
    case /* RecordingMode */2 :
        return {
                TAG: /* RecordingMode */2,
                _0: Curry._1(mapRecordingState, state._0)
              };
    case /* PlaybackMode */3 :
        return {
                TAG: /* PlaybackMode */3,
                _0: Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.mapState, mapHtmlElement, mapDomEvent, state._0)
              };
    case /* UrlTriggeringMode */4 :
        return {
                TAG: /* UrlTriggeringMode */4,
                _0: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapState(mapHtmlElement, mapDomEvent, state._0)
              };
    case /* DataExtractionMode */5 :
        return {
                TAG: /* DataExtractionMode */5,
                _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapState(mapHtmlElement, state._0)
              };
    
  }
}

function mapEvent$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, $$event) {
  if (typeof $$event === "number") {
    return /* Initialize */0;
  }
  switch ($$event.TAG | 0) {
    case /* BasicEventRootLevel */0 :
        return {
                TAG: /* BasicEventRootLevel */0,
                _0: $$event._0
              };
    case /* BgDidAckContentScriptReady */1 :
        return {
                TAG: /* BgDidAckContentScriptReady */1,
                _0: $$event._0
              };
    case /* DidRespondToBgWithContentScriptFailureId */2 :
        return {
                TAG: /* DidRespondToBgWithContentScriptFailureId */2,
                _0: $$event._0,
                _1: $$event._1,
                _2: mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, $$event._2)
              };
    case /* DidSetupLinkTriggerListener */3 :
        return {
                TAG: /* DidSetupLinkTriggerListener */3,
                _0: $$event._0
              };
    case /* RecordingModeEvent */4 :
        return {
                TAG: /* RecordingModeEvent */4,
                _0: Curry._1(mapRecordingEvent, $$event._0)
              };
    case /* PlaybackModeEvent */5 :
        return {
                TAG: /* PlaybackModeEvent */5,
                _0: Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.mapEvent, mapHtmlElement, mapDomEvent, $$event._0)
              };
    case /* UrlTriggeringModeEvent */6 :
        return {
                TAG: /* UrlTriggeringModeEvent */6,
                _0: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapEvent(mapHtmlElement, mapDomEvent, $$event._0)
              };
    case /* DataExtractionModeEvent */7 :
        return {
                TAG: /* DataExtractionModeEvent */7,
                _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapEvent(mapHtmlElement, mapDomMutationRecord, mapDomEvent, $$event._0)
              };
    case /* Fail */8 :
        return {
                TAG: /* Fail */8,
                _0: mapFailure$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, $$event._0)
              };
    case /* ContextMenuEventDidFireOnElement */9 :
        return {
                TAG: /* ContextMenuEventDidFireOnElement */9,
                _0: Curry._1(mapHtmlElement, $$event._0)
              };
    
  }
}

function mapFailure$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, (function (param) {
                return mapState$5(mapRecordingState, mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapEvent$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
              }), (function (param) {
                return mapSideEffect$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
              }), (function (param) {
                return mapListener$4(mapDomEvent, mapDomMutationRecord, param);
              }), failure);
}

function mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, errorContext) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.map, (function (param) {
                return mapState$5(mapRecordingState, mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapEvent$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
              }), (function (param) {
                return mapSideEffect$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, param);
              }), (function (param) {
                return mapListener$4(mapDomEvent, mapDomMutationRecord, param);
              }), errorContext);
}

function mapSideEffect$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* ResetStateMachineHistory */0 :
          return /* ResetStateMachineHistory */0;
      case /* NotifyBgThatContentScriptReady */1 :
          return /* NotifyBgThatContentScriptReady */1;
      case /* SetupLinkTriggerListener */2 :
          return /* SetupLinkTriggerListener */2;
      case /* RemoveRenderedContent */3 :
          return /* RemoveRenderedContent */3;
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* Dispatch */0 :
          return {
                  TAG: /* Dispatch */0,
                  _0: mapEvent$5(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._0)
                };
      case /* NotifyBgOfContentScriptFailure */1 :
          return {
                  TAG: /* NotifyBgOfContentScriptFailure */1,
                  _0: sideEffect._0,
                  _1: mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._1)
                };
      case /* NotifyBgOfContentScriptResponseFailure */2 :
          return {
                  TAG: /* NotifyBgOfContentScriptResponseFailure */2,
                  _0: sideEffect._0,
                  _1: sideEffect._1,
                  _2: mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._2)
                };
      case /* TeardownLinkTriggerListener */3 :
          return {
                  TAG: /* TeardownLinkTriggerListener */3,
                  _0: sideEffect._0
                };
      case /* RecordingModeSideEffect */4 :
          return {
                  TAG: /* RecordingModeSideEffect */4,
                  _0: Curry._1(mapRecordingSideEffect, sideEffect._0)
                };
      case /* PlaybackModeSideEffect */5 :
          return {
                  TAG: /* PlaybackModeSideEffect */5,
                  _0: Curry._3(ContentScript__StateMachine__PlaybackMode__Types__Helpers.mapSideEffect, mapHtmlElement, mapDomEvent, sideEffect._0)
                };
      case /* UrlTriggeringModeSideEffect */6 :
          return {
                  TAG: /* UrlTriggeringModeSideEffect */6,
                  _0: ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.mapSideEffect(mapHtmlElement, mapDomEvent, sideEffect._0)
                };
      case /* DataExtractionModeSideEffect */7 :
          return {
                  TAG: /* DataExtractionModeSideEffect */7,
                  _0: ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.mapSideEffect(mapHtmlElement, mapDomMutationRecord, mapDomEvent, sideEffect._0)
                };
      case /* WindowAlert */8 :
          return {
                  TAG: /* WindowAlert */8,
                  _0: sideEffect._0
                };
      case /* ConsoleJsPromiseError */9 :
          return {
                  TAG: /* ConsoleJsPromiseError */9,
                  _0: sideEffect._0,
                  _1: mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._1)
                };
      case /* ConsoleJsExn */10 :
          return {
                  TAG: /* ConsoleJsExn */10,
                  _0: sideEffect._0,
                  _1: mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._1)
                };
      case /* RespondToBg */11 :
          return {
                  TAG: /* RespondToBg */11,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* RespondToBgWithFailure */12 :
          return {
                  TAG: /* RespondToBgWithFailure */12,
                  _0: sideEffect._0,
                  _1: sideEffect._1,
                  _2: mapErrorContext(mapDomEvent, mapDomMutationRecord, mapRecordingState, mapRecordingEvent, mapRecordingSideEffect, mapHtmlElement, sideEffect._2)
                };
      case /* RenderOnHostPage */13 :
          return {
                  TAG: /* RenderOnHostPage */13,
                  _0: sideEffect._0
                };
      case /* RenderHtmlMarkup */14 :
          return {
                  TAG: /* RenderHtmlMarkup */14,
                  _0: sideEffect._0
                };
      case /* UpdateRenderedContentGeometry */15 :
          return {
                  TAG: /* UpdateRenderedContentGeometry */15,
                  _0: sideEffect._0
                };
      case /* CheckIfElementExistsOnPageAndRespond */16 :
          return {
                  TAG: /* CheckIfElementExistsOnPageAndRespond */16,
                  _0: sideEffect._0,
                  _1: sideEffect._1,
                  _2: sideEffect._2
                };
      
    }
  }
}

var stringifyDomMutationRecord$6 = DOM$SmartcutsMacros.$$MutationRecord.stringify;

function stringifyState$14(param) {
  return stringifyState$13((function (param) {
                return "htmlElement";
              }), DOM__Event$SmartcutsMacros.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, param);
}

function stringifyEvent$15(param) {
  return stringifyEvent$14((function (param) {
                return "htmlElement";
              }), DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifySideEffect, param);
}

function stringifySideEffect$14(param) {
  return stringifySideEffect$13((function (param) {
                return "htmlElement";
              }), DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifySideEffect, param);
}

function stringifyErrorContext$1(param) {
  return stringifyErrorContext((function (param) {
                return "htmlElement";
              }), DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.Regular.stringifySideEffect, param);
}

function stringifyListener$7(param) {
  return stringifyListener$6(DOM__Event$SmartcutsMacros.stringify, stringifyDomMutationRecord$6, param);
}

function prepareStateForSerialization$4(state) {
  return mapState$5(ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, DOM__Event__ForSerialization$SmartcutsMacros.make, state);
}

function prepareEventForSerialization$4($$event) {
  return mapEvent$5(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareEventForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareSideEffectForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, $$event);
}

function prepareSideEffectForSerialization$4(sideEffect) {
  return mapSideEffect$5(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareEventForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareSideEffectForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, sideEffect);
}

function prepareListenerForSerialization$1(listener) {
  return mapListener$4(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, listener);
}

function prepareErrorContextForSerialization(errorContext) {
  return mapErrorContext(DOM__Event__ForSerialization$SmartcutsMacros.make, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.fromMutationRecord, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareStateForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareEventForSerialization, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.prepareSideEffectForSerialization, DOM__HtmlElement$SmartcutsMacros.ForSerialization.fromDomHtmlElement, errorContext);
}

function stringifyState$15(param) {
  return stringifyState$13(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, param);
}

function stringifyEvent$16(param) {
  return stringifyEvent$14(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifySideEffect, param);
}

function stringifySideEffect$15(param) {
  return stringifySideEffect$13(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifySideEffect, param);
}

function stringifyListener$8(param) {
  return stringifyListener$6(DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, param);
}

function stringifyErrorContext$2(param) {
  return stringifyErrorContext(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, DOM__Event__ForSerialization$SmartcutsMacros.stringify, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.stringify, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyState, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifyEvent, ContentScript__StateMachine__RecordingMode__Types__Helpers.ForSerialization.stringifySideEffect, param);
}

var stringifyFailureInfo = Curry._5(StateMachine$SmartcutsMacros.Failure.Root.FailureInfo.stringify, stringifyState$15, stringifyEvent$16, stringifySideEffect$15, stringifyListener$8, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason);

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyOtherFailureReason"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyErrorContext"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "mapListener"
              ],
              [
                /* Function */0,
                "mapState"
              ],
              [
                /* Function */0,
                "mapEvent"
              ],
              [
                /* Function */0,
                "mapFailure"
              ],
              [
                /* Function */0,
                "mapErrorContext"
              ],
              [
                /* Function */0,
                "mapSideEffect"
              ]
            ]
          },
          "Generic"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyErrorContext"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ]
            ]
          },
          "Regular"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "prepareStateForSerialization"
              ],
              [
                /* Function */0,
                "prepareEventForSerialization"
              ],
              [
                /* Function */0,
                "prepareSideEffectForSerialization"
              ],
              [
                /* Function */0,
                "prepareListenerForSerialization"
              ],
              [
                /* Function */0,
                "prepareErrorContextForSerialization"
              ],
              [
                /* Function */0,
                "stringifyState"
              ],
              [
                /* Function */0,
                "stringifyEvent"
              ],
              [
                /* Function */0,
                "stringifySideEffect"
              ],
              [
                /* Function */0,
                "stringifyErrorContext"
              ],
              [
                /* Function */0,
                "stringifyListener"
              ],
              [
                /* Function */0,
                "stringifyFailureInfo"
              ]
            ]
          },
          "ForSerialization"
        ]
      ]
    }, ContentScript__StateMachine__Types__Helpers, {
      Generic: {
        stringifyOtherFailureReason: ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason,
        stringifyState: stringifyState$13,
        stringifyErrorContext: stringifyErrorContext,
        stringifyEvent: stringifyEvent$14,
        stringifySideEffect: stringifySideEffect$13,
        stringifyListener: stringifyListener$6,
        mapListener: mapListener$4,
        mapState: mapState$5,
        mapEvent: mapEvent$5,
        mapFailure: mapFailure$5,
        mapErrorContext: mapErrorContext,
        mapSideEffect: mapSideEffect$5
      },
      Regular: {
        stringifyState: stringifyState$14,
        stringifyEvent: stringifyEvent$15,
        stringifySideEffect: stringifySideEffect$14,
        stringifyErrorContext: stringifyErrorContext$1,
        stringifyListener: stringifyListener$7
      },
      ForSerialization: {
        prepareStateForSerialization: prepareStateForSerialization$4,
        prepareEventForSerialization: prepareEventForSerialization$4,
        prepareSideEffectForSerialization: prepareSideEffectForSerialization$4,
        prepareListenerForSerialization: prepareListenerForSerialization$1,
        prepareErrorContextForSerialization: prepareErrorContextForSerialization,
        stringifyState: stringifyState$15,
        stringifyEvent: stringifyEvent$16,
        stringifySideEffect: stringifySideEffect$15,
        stringifyErrorContext: stringifyErrorContext$2,
        stringifyListener: stringifyListener$8,
        stringifyFailureInfo: stringifyFailureInfo
      }
    });

function stringifyMessage(message) {
  return "StartStreamingEventsToBackground";
}

function stringifyResponse(response) {
  return "TabDidSetupEventStreaming";
}

var StartStreamingEventsToBackground = {
  stringifyMessage: stringifyMessage,
  stringifyResponse: stringifyResponse
};

function stringifyMessage$1(message) {
  return "StopStreamingEventsToBackground";
}

function stringifyResponse$1(response) {
  return "TabDidStopStreamingEventsToBackground";
}

var StopStreamingEventsToBackground = {
  stringifyMessage: stringifyMessage$1,
  stringifyResponse: stringifyResponse$1
};

function stringifyMessage$2(message) {
  return "Playback(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.stringify, message._0) + "playbackOptions, preconditions)");
}

function stringifyResponse$2(response) {
  if (typeof response === "number") {
    return "TabDidPlaybackCommand";
  }
  switch (response.TAG | 0) {
    case /* TabDidClickLink */0 :
        return "TabDidClickLink(" + (response._0 + ")");
    case /* TabDidCopyText */1 :
        return "TabDidCopyText(" + (response._0 + ")");
    case /* TabDidTakeScreenshot */2 :
        return "TabDidTakeScreenshot(objectUrl=" + (StringUtils$SmartcutsMacros.quote(response._0) + (", metadata=" + (Image$SmartcutsMacros.Metadata.stringify(response._1) + ")")));
    case /* TabDidCollectDataGroups */3 :
        var stringifyDataNode = function (param) {
          return "{ dataNodeId: " + (DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.stringify(param.dataNodeId) + (", domEntities: " + (Belt_Array.map(param.domEntities, (function (domElementOrTextNode) {
                                if (domElementOrTextNode.TAG === /* HtmlElement */0) {
                                  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.stringify(domElementOrTextNode._0);
                                } else {
                                  return domElementOrTextNode._0;
                                }
                              })).join(", ") + " }")));
        };
        return "TabDidCollectDataGroups({ dataRecordsWithDataNodeId: [" + (Belt_Array.map(response._0.dataRecordsWithDataNodeId, (function (param) {
                          return "{ friendlyName: " + (OptionUtils$SmartcutsMacros.stringify((function (str) {
                                          return str;
                                        }), param.friendlyName) + (", properties: [" + (Belt_Array.map(param.properties, (function (param) {
                                                return "{ dataNode: " + (stringifyDataNode(param.dataNode) + " }");
                                              })).join(", ") + "] }")));
                        })).join(", ") + "] })");
    case /* TabCouldNotFindElement */4 :
        return "TabCouldNotFindElement(" + (response._0 + (", " + (SelectorOverrides$SmartcutsMacros.stringifyElementLocatorInTermsOfStrategy(response._1, true, (function (selector) {
                            var arg = ListUtils$SmartcutsMacros.last(selector);
                            return "(chain=" + (Belt_Array.map($$Array.of_list(selector), (function (param) {
                                              return OptionUtils$SmartcutsMacros.getExn("Expect all selectorNodes to have tagName", param.tagName);
                                            })).join(" > ") + (", lastNode=" + ((function (param) {
                                              return OptionUtils$SmartcutsMacros.stringify(param, arg);
                                            })(SelectorTree$SmartcutsMacros.$$Node.stringify) + ")")));
                          })) + ")")));
    case /* TabOrWindowNotVisible */5 :
        return "TabOrWindowNotVisible(" + (response._0 + ")");
    case /* TabOrWindowVisibilityUnknownOrUnloaded */6 :
        return "TabOrWindowVisibilityUnknownOrUnloaded(" + (response._0 + ")");
    case /* TabCouldNotApplySemantic */7 :
        return "TabCouldNotApplySemantic(error, " + (response._1 + ")");
    case /* TabCannotCopyMissingSrcOfImg */8 :
        return "TabCannotCopyMissingSrcOfImg(" + (response._0 + (", " + (SelectorOverrides$SmartcutsMacros.stringifyElementLocatorInTermsOfStrategy(response._1, true, (function (selector) {
                            var arg = ListUtils$SmartcutsMacros.last(selector);
                            return "(chain=" + (Belt_Array.map($$Array.of_list(selector), (function (param) {
                                              return OptionUtils$SmartcutsMacros.getExn("Expect all selectorNodes to have tagName", param.tagName);
                                            })).join(" > ") + (", lastNode=" + ((function (param) {
                                              return OptionUtils$SmartcutsMacros.stringify(param, arg);
                                            })(SelectorTree$SmartcutsMacros.$$Node.stringify) + ")")));
                          })) + ")")));
    case /* TabCouldNotPlaybackBecauseOverlayBlockingTargetElement */9 :
        var match = response._0;
        return "TabCouldNotPlaybackBecauseOverlayBlockingTargetElement({element: " + (match.element + (", maybeOverlayElement: " + (OptionUtils$SmartcutsMacros.withDefault("None", match.maybeOverlayElement) + (", ms: " + (match.ms.toString() + ("}, " + (response._1 + ")")))))));
    case /* ErrorWhileWaitForOverlayToStopBlockingElement */10 :
        return "ErrorWhileWaitForOverlayToStopBlockingElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, response._0) + (", " + (response._1 + ")")));
    case /* ErrorWhileSearchForElement */11 :
        return "ErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, response._0) + (", " + (response._1 + ")")));
    case /* TabDidEvaluateSwitchCommand */12 :
        var tabDidEvaluateSwitchCommand = response._0;
        var tmp;
        tmp = typeof tabDidEvaluateSwitchCommand === "number" ? "FailWithNoPredicateSatisfied" : (
            tabDidEvaluateSwitchCommand.TAG === /* ResolvedToCommands */0 ? "ResolvedToCommands(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.SwitchCommandPlaybackRuntime.stringifyResolvedToCommands, tabDidEvaluateSwitchCommand._0) + ")") : "ResolvedToDoNothing(" + (Curry._1(CommandPlaybackRuntime$SmartcutsMacros.SwitchCommandPlaybackRuntime.stringifyCaseThatEvaluatedToTrue, tabDidEvaluateSwitchCommand._0) + ")")
          );
        return "TabDidEvaluateSwitchCommand(" + (tmp + ")");
    case /* UnimplementedInTab */13 :
        return "UnimplementedInTab(" + (StringUtils$SmartcutsMacros.quote(response._0) + ")");
    
  }
}

var Playback = {
  stringifyMessage: stringifyMessage$2,
  stringifyResponse: stringifyResponse$2
};

function stringifyMessage$3(message) {
  return "PlaybackExited";
}

function stringifyResponse$3(response) {
  return "AckPlaybackExited";
}

var PlaybackExited = {
  stringifyMessage: stringifyMessage$3,
  stringifyResponse: stringifyResponse$3
};

function stringifyMessage$4(message) {
  if (message) {
    return "RenderInContentScript(" + (RenderOnHost$SmartcutsMacros.stringify(message._0) + ")");
  } else {
    return "RemoveRenderedContent";
  }
}

function stringifyResponse$4(response) {
  return "AckRenderInContentScript";
}

var RenderInContentScript = {
  stringifyMessage: stringifyMessage$4,
  stringifyResponse: stringifyResponse$4
};

function stringifyMessage$5(message) {
  return "AskContentScriptToAdjustModalGeometry(" + (RenderOnHost__Geometry$SmartcutsMacros.stringify(message._0) + ")");
}

function stringifyResponse$5(response) {
  if (response) {
    return "ContentScriptDidNotAdjustModalGeometry";
  } else {
    return "ContentScriptDidAdjustModalGeometry";
  }
}

var AskContentScriptToAdjustModalGeometry = {
  stringifyMessage: stringifyMessage$5,
  stringifyResponse: stringifyResponse$5
};

function stringifyMessage$6(message) {
  var match = message._0;
  return "AskContentScriptToEnterUrlTriggeringMode({ maybeTriggeringLinkUrlAndText" + (OptionUtils$SmartcutsMacros.stringify((function (param) {
                  return "Some(linkUrl, maybeSelectionText)";
                }), match.maybeTriggeringLinkUrlAndText) + (", isPlaybackMode: " + (Pervasives.string_of_bool(match.isPlaybackMode) + " })")));
}

function stringifyResponse$6(response) {
  if (response) {
    return "RequiresUserToTryAgain";
  } else {
    return "ContentScriptDidEnterUrlTriggeringMode";
  }
}

var AskContentScriptToEnterUrlTriggeringMode = {
  stringifyMessage: stringifyMessage$6,
  stringifyResponse: stringifyResponse$6
};

function stringifyMessage$7(message) {
  var arg = OptionUtils$SmartcutsMacros.map(message._4, MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify);
  return "RefreshLinks(links(length=" + (String(message._0.length) + ("), linkGroups(length=" + (String(Belt_MapString.size(message._1)) + ("), urlPattern, step=" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringify(message._3) + (", paginateFn=" + ((function (param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                          })("None") + ")")))))));
}

function stringifyResponse$7(response) {
  if (response) {
    return "LinksUpdated(array(length=" + (String(response._0.length) + "))");
  } else {
    return "NoUpdate";
  }
}

var UrlTriggering_RefreshLinks = {
  stringifyMessage: stringifyMessage$7,
  stringifyResponse: stringifyResponse$7
};

function stringifyMessage$8(message) {
  return "UpdateLinks(array(length=" + (String(message._0.length) + "))");
}

function stringifyResponse$8(response) {
  return "AckLinksUpdated";
}

var UrlTriggering_UpdateLinks = {
  stringifyMessage: stringifyMessage$8,
  stringifyResponse: stringifyResponse$8
};

function stringifyMessage$9(message) {
  return "TellTabToUpdateLinkGroups(size=" + (String(Belt_MapString.size(message._0)) + ")");
}

function stringifyResponse$9(response) {
  return "AckUpdateLinkGroups";
}

var UrlTriggering_TellTabToUpdateLinkGroups = {
  stringifyMessage: stringifyMessage$9,
  stringifyResponse: stringifyResponse$9
};

function stringifyMessage$10(message) {
  return "Exit";
}

function stringifyResponse$10(response) {
  return "AckExit";
}

var UrlTriggering_Exit = {
  stringifyMessage: stringifyMessage$10,
  stringifyResponse: stringifyResponse$10
};

function stringifyMessage$11(message) {
  return "AskContentScriptToRecordPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringifyPageAction(message._0) + ")");
}

function stringifyResponse$11(response) {
  return "ContentScriptDidRecordPageAction";
}

var UrlTriggering_AskContentScriptToRecordPageAction = {
  stringifyMessage: stringifyMessage$11,
  stringifyResponse: stringifyResponse$11
};

function stringifyMessage$12(message) {
  return "StopRecordPageAction";
}

function stringifyResponse$12(response) {
  return "AckStopRecordPageAction";
}

var UrlTriggering_StopRecordPageAction = {
  stringifyMessage: stringifyMessage$12,
  stringifyResponse: stringifyResponse$12
};

function stringifyMessage$13(message) {
  return "PlaybackPageActionUntil(" + (MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil(message._0) + ")");
}

function stringifyResponse$13(response) {
  return "AckPlaybackPageAction";
}

var UrlTriggering_PlaybackPageAction = {
  stringifyMessage: stringifyMessage$13,
  stringifyResponse: stringifyResponse$13
};

function stringifyMessage$14(message) {
  return "DidFinishPlaybackPageAction";
}

function stringifyResponse$14(response) {
  return "AckDidFinishPlaybackPageAction";
}

var UrlTriggering_DidFinishPlaybackPageAction = {
  stringifyMessage: stringifyMessage$14,
  stringifyResponse: stringifyResponse$14
};

function stringifyMessage$15(message) {
  return "ShowLinkWithId(" + (message._0 + ")");
}

function stringifyResponse$15(response) {
  return "AckShowLinkWithId";
}

var UrlTriggering_ShowLinkWithId = {
  stringifyMessage: stringifyMessage$15,
  stringifyResponse: stringifyResponse$15
};

function stringifyMessage$16(message) {
  return "PrepareForScreenshot";
}

function stringifyResponse$16(response) {
  return "AckPrepareForScreenshot";
}

var UrlTriggering_PrepareForScreenshot = {
  stringifyMessage: stringifyMessage$16,
  stringifyResponse: stringifyResponse$16
};

function stringifyMessage$17(message) {
  return "SendContextLocalAndLinkGroups";
}

function stringifyResponse$17(response) {
  return "GotContextLocalAndLinkGroups(contextLocal, selectedLinkGroups=array(length=" + (String(response._1.length) + "))");
}

var UrlTriggering_SendContextLocalAndLinkGroups = {
  stringifyMessage: stringifyMessage$17,
  stringifyResponse: stringifyResponse$17
};

function stringifyMessage$18(message) {
  return "Ping";
}

function stringifyResponse$18(response) {
  return "Ack";
}

var PingTab = {
  stringifyMessage: stringifyMessage$18,
  stringifyResponse: stringifyResponse$18
};

function stringifyMessage$19(message) {
  var arg = Belt_Option.map(message._1, InnerTextSemantic$SmartcutsMacros.stringify);
  return "DoesElementExistOnPage(selector=" + (Selector$SmartcutsMacros.stringifyElementSelector(message._0) + (", innerTextSemantic" + ((function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  })("None") + ")")));
}

function stringifyResponse$19(response) {
  if (response) {
    return "DidNotFindElement";
  } else {
    return "DidFindElement";
  }
}

var DoesElementExistOnPage = {
  stringifyMessage: stringifyMessage$19,
  stringifyResponse: stringifyResponse$19
};

function stringifyMessage$20(message) {
  return "AskTabToRenderModalToExplainHighlightElement";
}

function stringifyResponse$20(response) {
  return "AckRenderModalToExplainHighlightElement";
}

var AskTabToRenderModalToExplainHighlightElement = {
  stringifyMessage: stringifyMessage$20,
  stringifyResponse: stringifyResponse$20
};

function stringifyMessage$21(message) {
  return "AskTabToSetupHighlightElementControl(callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(message._0) + ")");
}

function stringifyResponse$21(response) {
  return "DidSetupHighlightElementControl";
}

var AskTabToSetupHighlightElementControl = {
  stringifyMessage: stringifyMessage$21,
  stringifyResponse: stringifyResponse$21
};

function stringifyMessage$22(message) {
  return "AskTabToTeardownHighlightElementControl";
}

function stringifyResponse$22(response) {
  return "DidTeardownHighlightElementControl";
}

var AskTabToTeardownHighlightElementControl = {
  stringifyMessage: stringifyMessage$22,
  stringifyResponse: stringifyResponse$22
};

function stringifyMessage$23(message) {
  return "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand";
}

function stringifyResponse$23(response) {
  return "DidHideSmartcutsPlaybackModalUntilCompletedCommand";
}

var AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = {
  stringifyMessage: stringifyMessage$23,
  stringifyResponse: stringifyResponse$23
};

function stringifyMessage$24(message) {
  return "AskTabToEnterDataExtractionMode";
}

function stringifyResponse$24(response) {
  return "TabDidEnterDataExtractionMode({newWindowCommandWithContextLocal})";
}

var AskTabToEnterDataExtractionMode = {
  stringifyMessage: stringifyMessage$24,
  stringifyResponse: stringifyResponse$24
};

function stringifyMessage$25(message) {
  return "AskTabToExitDataExtractionMode";
}

function stringifyResponse$25(response) {
  return "TabDidExitDataExtractionMode";
}

var AskTabToExitDataExtractionMode = {
  stringifyMessage: stringifyMessage$25,
  stringifyResponse: stringifyResponse$25
};

function stringifyMessage$26(message) {
  switch (message.TAG | 0) {
    case /* Message_StartStreamingEventsToBackground */0 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.StartStreamingEventsToBackground.stringifyMessage, message._0);
    case /* Message_StopStreamingEventsToBackground */1 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.StopStreamingEventsToBackground.stringifyMessage, message._0);
    case /* Message_Playback */2 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.Playback.stringifyMessage, message._0);
    case /* Message_PlaybackExited */3 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.PlaybackExited.stringifyMessage, message._0);
    case /* Message_RenderInContentScript */4 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.RenderInContentScript.stringifyMessage, message._0);
    case /* Message_AskContentScriptToAdjustModalGeometry */5 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToAdjustModalGeometry.stringifyMessage, message._0);
    case /* Message_AskContentScriptToEnterUrlTriggeringMode */6 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToEnterUrlTriggeringMode.stringifyMessage, message._0);
    case /* Message_UrlTriggering_RefreshLinks */7 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_RefreshLinks.stringifyMessage, message._0);
    case /* Message_UrlTriggering_UpdateLinks */8 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_UpdateLinks.stringifyMessage, message._0);
    case /* Message_UrlTriggering_TellTabToUpdateLinkGroups */9 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_TellTabToUpdateLinkGroups.stringifyMessage, message._0);
    case /* Message_UrlTriggering_Exit */10 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_Exit.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskContentScriptToRecordPageAction */11 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_AskContentScriptToRecordPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_StopRecordPageAction */12 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_StopRecordPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_PlaybackPageAction */13 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PlaybackPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_DidFinishPlaybackPageAction */14 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_DidFinishPlaybackPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_ShowLinkWithId */15 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_ShowLinkWithId.stringifyMessage, message._0);
    case /* Message_UrlTriggering_SendContextLocalAndLinkGroups */16 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_SendContextLocalAndLinkGroups.stringifyMessage, message._0);
    case /* Message_UrlTriggering_PrepareForScreenshot */17 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PrepareForScreenshot.stringifyMessage, message._0);
    case /* Message_PingTab */18 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.PingTab.stringifyMessage, message._0);
    case /* Message_DoesElementExistOnPage */19 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.DoesElementExistOnPage.stringifyMessage, message._0);
    case /* Message_AskTabToRenderModalToExplainHighlightElement */20 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToRenderModalToExplainHighlightElement.stringifyMessage, message._0);
    case /* Message_AskTabToSetupHighlightElementControl */21 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToSetupHighlightElementControl.stringifyMessage, message._0);
    case /* Message_AskTabToTeardownHighlightElementControl */22 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToTeardownHighlightElementControl.stringifyMessage, message._0);
    case /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand.stringifyMessage, message._0);
    case /* Message_AskTabToEnterDataExtractionMode */24 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToEnterDataExtractionMode.stringifyMessage, message._0);
    case /* Message_AskTabToExitDataExtractionMode */25 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToExitDataExtractionMode.stringifyMessage, message._0);
    
  }
}

function stringifyResponse$26(response) {
  switch (response.TAG | 0) {
    case /* Response_StartStreamingEventsToBackground */0 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.StartStreamingEventsToBackground.stringifyResponse, response._0);
    case /* Response_StopStreamingEventsToBackground */1 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.StopStreamingEventsToBackground.stringifyResponse, response._0);
    case /* Response_Playback */2 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.Playback.stringifyResponse, response._0);
    case /* Response_PlaybackExited */3 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.PlaybackExited.stringifyResponse, response._0);
    case /* Response_RenderInContentScript */4 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.RenderInContentScript.stringifyResponse, response._0);
    case /* Response_AskContentScriptToAdjustModalGeometry */5 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToAdjustModalGeometry.stringifyResponse, response._0);
    case /* Response_AskContentScriptToEnterUrlTriggeringMode */6 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskContentScriptToEnterUrlTriggeringMode.stringifyResponse, response._0);
    case /* Response_UrlTriggering_RefreshLinks */7 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_RefreshLinks.stringifyResponse, response._0);
    case /* Response_UrlTriggering_UpdateLinks */8 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_UpdateLinks.stringifyResponse, response._0);
    case /* Response_UrlTriggering_TellTabToUpdateLinkGroups */9 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_TellTabToUpdateLinkGroups.stringifyResponse, response._0);
    case /* Response_UrlTriggering_Exit */10 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_Exit.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskContentScriptToRecordPageAction */11 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_AskContentScriptToRecordPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_StopRecordPageAction */12 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_StopRecordPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_PlaybackPageAction */13 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PlaybackPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_DidFinishPlaybackPageAction */14 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_DidFinishPlaybackPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_ShowLinkWithId */15 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_ShowLinkWithId.stringifyResponse, response._0);
    case /* Response_UrlTriggering_SendContextLocalAndLinkGroups */16 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_SendContextLocalAndLinkGroups.stringifyResponse, response._0);
    case /* Response_UrlTriggering_PrepareForScreenshot */17 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.UrlTriggering_PrepareForScreenshot.stringifyResponse, response._0);
    case /* Response_PingTab */18 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.PingTab.stringifyResponse, response._0);
    case /* Response_DoesElementExistOnPage */19 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.DoesElementExistOnPage.stringifyResponse, response._0);
    case /* Response_AskTabToRenderModalToExplainHighlightElement */20 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToRenderModalToExplainHighlightElement.stringifyResponse, response._0);
    case /* Response_AskTabToSetupHighlightElementControl */21 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToSetupHighlightElementControl.stringifyResponse, response._0);
    case /* Response_AskTabToTeardownHighlightElementControl */22 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToTeardownHighlightElementControl.stringifyResponse, response._0);
    case /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand.stringifyResponse, response._0);
    case /* Response_AskTabToEnterDataExtractionMode */24 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToEnterDataExtractionMode.stringifyResponse, response._0);
    case /* Response_AskTabToExitDataExtractionMode */25 :
        return Curry._1(ExtensionMessagingLogging.FromExtension.AskTabToExitDataExtractionMode.stringifyResponse, response._0);
    
  }
}

var All = {
  stringifyMessage: stringifyMessage$26,
  stringifyResponse: stringifyResponse$26
};

function stringifyMessage$27(message) {
  return "ContentScriptReady";
}

function stringifyResponse$27(response) {
  switch (response) {
    case /* AttachToRecording */0 :
        return "AttachToRecording";
    case /* AttachToPlayback */1 :
        return "AttachToPlayback";
    case /* AckContentScriptReady */2 :
        return "AckContentScriptReady";
    
  }
}

var ContentScriptReady = {
  stringifyMessage: stringifyMessage$27,
  stringifyResponse: stringifyResponse$27
};

function stringifyMessage$28(message) {
  return "AskBgToRefreshAuthStatus";
}

function stringifyResponse$28(response) {
  return "DidRefreshAuthStatus(" + (AuthStatus$SmartcutsMacros.stringify(response._0) + ")");
}

var AskBgToRefreshAuthStatus = {
  stringifyMessage: stringifyMessage$28,
  stringifyResponse: stringifyResponse$28
};

function stringifyMessage$29(message) {
  return "AskBgToFetchPlanSubscriptionProgress";
}

function stringifyResponse$29(response) {
  if (typeof response !== "number") {
    return "DidFetchRemainingExecutionSteps(" + (String(response._0) + (", " + (String(response._1) + (", " + (StringUtils$SmartcutsMacros.quote(response._2) + (", " + (new Date(response._3).toISOString() + ")")))))));
  }
  switch (response) {
    case /* NotLoggedIn */0 :
        return "NotLoggedIn";
    case /* HasNoActiveSubscription */1 :
        return "HasNoActiveSubscription";
    case /* DbIssue */2 :
        return "DbIssue";
    
  }
}

var AskBgToFetchPlanSubscriptionProgress = {
  stringifyMessage: stringifyMessage$29,
  stringifyResponse: stringifyResponse$29
};

function stringifyMessage$30(message) {
  return "NotifyBgOfContentScriptFailure(failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, message._0) + (", errorContext=" + (Curry._1(ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, message._1) + ", history)")));
}

function stringifyResponse$30(response) {
  return "BgDidAckTabError";
}

var NotifyBgOfContentScriptFailure = {
  stringifyMessage: stringifyMessage$30,
  stringifyResponse: stringifyResponse$30
};

function stringifyMessage$31(message) {
  return "NotifyBgOfContentScriptResponseFailure(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(message._0) + (", failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, message._1) + (", errorContext=" + (Curry._1(ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, message._2) + ", history)")))));
}

function stringifyResponse$31(response) {
  return "BgDidAckNotifyBgOfContentScriptResponseFailure";
}

var NotifyBgOfContentScriptResponseFailure = {
  stringifyMessage: stringifyMessage$31,
  stringifyResponse: stringifyResponse$31
};

function stringifyMessage$32(message) {
  return "StartDebugSelector";
}

function stringifyResponse$32(response) {
  if (response) {
    return "BgCouldNotFindActiveTab";
  } else {
    return "BgDidStartDebugSelector";
  }
}

var StartDebugSelector = {
  stringifyMessage: stringifyMessage$32,
  stringifyResponse: stringifyResponse$32
};

function stringifyMessage$33(message) {
  if (!message) {
    return "StartRecording";
  }
  var match = message._0;
  return "StartRecordingLoginSmartcut({ mainSmartcutId:" + (match.mainSmartcutId + (", startingUrl: " + (match.startingUrl + " })")));
}

function stringifyResponse$33(response) {
  switch (response) {
    case /* BgDidStartRecording */0 :
        return "BgDidStartRecording";
    case /* BgCouldNotFindActiveTab */1 :
        return "BgCouldNotFindActiveTab";
    case /* NotLoggedIn */2 :
        return "NotLoggedIn";
    
  }
}

var StartRecording = {
  stringifyMessage: stringifyMessage$33,
  stringifyResponse: stringifyResponse$33
};

function stringifyMessage$34(message) {
  return "StopRecording";
}

function stringifyResponse$34(response) {
  return "AckStopRecording";
}

var StopRecording = {
  stringifyMessage: stringifyMessage$34,
  stringifyResponse: stringifyResponse$34
};

function stringifyMessage$35(message) {
  return "DidStartRecording";
}

function stringifyResponse$35(response) {
  if (response) {
    return "BgExitedRecording";
  } else {
    return "BgRecording";
  }
}

var DidStartRecording = {
  stringifyMessage: stringifyMessage$35,
  stringifyResponse: stringifyResponse$35
};

function stringifyMessage$36(message) {
  var maybeBoundingRect = message._1;
  return "NotifyBgAboutPossibleCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(message._0) + (", boundingRect=" + ((
                maybeBoundingRect !== undefined ? JSON.stringify(Rect$SmartcutsMacros.t_encode(maybeBoundingRect)) : "None"
              ) + ")")));
}

function stringifyResponse$36(response) {
  return "AckPossibleCommand";
}

var NotifyBgAboutPossibleCommand = {
  stringifyMessage: stringifyMessage$36,
  stringifyResponse: stringifyResponse$36
};

function stringifyMessage$37(message) {
  return "ClearKeyThatDoesNotGenerateCommand(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(message._0) + ")");
}

function stringifyResponse$37(response) {
  return "AckClearKeyThatDoesNotGenerateCommand";
}

var ClearKeyThatDoesNotGenerateCommand = {
  stringifyMessage: stringifyMessage$37,
  stringifyResponse: stringifyResponse$37
};

function stringifyMessage$38(message) {
  if (message.TAG === /* RecordCommand */0) {
    return "RecordCommand(" + (Command$SmartcutsMacros.CommandWithContextLocal.stringify(message._0) + (", " + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(message._1, (function (param) {
                            return "(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(param[0]) + (", " + (String(param[1]) + ")")));
                          }))) + ")")));
  } else {
    return "RecordCommands([" + ($$String.concat(", ", List.map(Command$SmartcutsMacros.CommandWithContextLocal.stringify, message._0)) + ("], " + (OptionUtils$SmartcutsMacros.withDefault("None", OptionUtils$SmartcutsMacros.map(message._1, (function (param) {
                            return "(" + (PendingCommandInfo$SmartcutsMacros.keyAsString(param[0]) + (", " + (String(param[1]) + ")")));
                          }))) + ")")));
  }
}

function stringifyResponse$38(response) {
  if (response) {
    return "BgDidIgnoreCommand";
  } else {
    return "BgDidRecordCommand";
  }
}

var RecordCommand = {
  stringifyMessage: stringifyMessage$38,
  stringifyResponse: stringifyResponse$38
};

function stringifyMessage$39(message) {
  return "FinishAuthoring(smartcutData)";
}

function stringifyResponse$39(response) {
  if (response) {
    return "AckFinishAuthoring(" + (response._0 + ")");
  } else {
    return "NotLoggedIn";
  }
}

var FinishAuthoring = {
  stringifyMessage: stringifyMessage$39,
  stringifyResponse: stringifyResponse$39
};

function stringifyMessage$40(message) {
  return "OpenPageForSmartcutId(" + message._0 + ")";
}

function stringifyResponse$40(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "NotLoggedIn";
    } else {
      return "BgDidOpenSmartcutPage";
    }
  } else {
    return "DidNotFindSmartcutToOpenPage(" + response._0 + ")";
  }
}

var OpenPageForSmartcutId = {
  stringifyMessage: stringifyMessage$40,
  stringifyResponse: stringifyResponse$40
};

function stringifyMessage$41(message) {
  return "ShowFormForSmartcutId(" + message._0 + ")";
}

function stringifyResponse$41(response) {
  if (response) {
    return "DidNotFindSmartcutToOpenForm(" + response._0 + ")";
  } else {
    return "BgDidShowFormForSmartcutId";
  }
}

var ShowFormForSmartcutId = {
  stringifyMessage: stringifyMessage$41,
  stringifyResponse: stringifyResponse$41
};

function stringifyMessage$42(message) {
  return "AskBgToAdjustModalGeometry(geometry)";
}

function stringifyResponse$42(response) {
  if (response) {
    return "BgDidNotAdjustModalGeometry";
  } else {
    return "BgDidAdjustModalGeometry";
  }
}

var AskBgToAdjustModalGeometry = {
  stringifyMessage: stringifyMessage$42,
  stringifyResponse: stringifyResponse$42
};

function stringifyMessage$43(message) {
  var match = message._0;
  return "InitializePlayback(installedSmartcutId=" + (match.installedSmartcutId + (", context, userSpecifiedPlaybackOptions=" + (PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.stringify(match.userSpecifiedPlaybackOptions) + ")")));
}

function stringifyResponse$43(response) {
  return "BgDidInitializePlayback";
}

var InitializePlayback = {
  stringifyMessage: stringifyMessage$43,
  stringifyResponse: stringifyResponse$43
};

function stringifyMessage$44(message) {
  return "GetAuthoringCommandLog(" + (message._0 + ")");
}

function stringifyResponse$44(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "NotLoggedIn";
    } else {
      return "DidNotFindAuthoringCommandLog";
    }
  } else {
    return "DidFindAuthoringCommandLog(commandLog)";
  }
}

var GetAuthoringCommandLog = {
  stringifyMessage: stringifyMessage$44,
  stringifyResponse: stringifyResponse$44
};

function stringifyMessage$45(message) {
  return "GetSmartcut(" + (message._0 + (", " + (Pervasives.string_of_bool(message._1) + ")")));
}

function stringifyResponse$45(response) {
  if (typeof response === "number") {
    return "NotLoggedIn";
  } else if (response.TAG === /* DidFindSmartcut */0) {
    return "DidFindSmartcut(smartcutData)";
  } else {
    return "DidNotFindSmartcut(installedSmartcutId" + (response._0 + ")");
  }
}

var GetSmartcut = {
  stringifyMessage: stringifyMessage$45,
  stringifyResponse: stringifyResponse$45
};

function stringifyMessage$46(message) {
  return "GetMySmartcuts";
}

function stringifyResponse$46(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "NotLoggedIn";
    } else {
      return "DidNotFindMySmartcuts";
    }
  } else {
    return "DidFindMySmartcuts(smartcuts)";
  }
}

var GetMySmartcuts = {
  stringifyMessage: stringifyMessage$46,
  stringifyResponse: stringifyResponse$46
};

function stringifyMessage$47(message) {
  return "InstallSmartcut(" + (message._0 + ")");
}

function stringifyResponse$47(response) {
  if (response.TAG === /* DidInstallSmartcut */0) {
    return "DidInstallSmartcut(" + (response._0 + ")");
  } else {
    return "DidNotInstallSmartcut(error)";
  }
}

var InstallSmartcut = {
  stringifyMessage: stringifyMessage$47,
  stringifyResponse: stringifyResponse$47
};

function stringifyMessage$48(message) {
  return "DeleteSmartcut(" + (message._0 + ")");
}

function stringifyResponse$48(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "NotLoggedIn";
    } else {
      return "DidDeleteSmartcut";
    }
  } else {
    return "DidNotDeleteSmartcut(error)";
  }
}

var DeleteSmartcut = {
  stringifyMessage: stringifyMessage$48,
  stringifyResponse: stringifyResponse$48
};

function stringifyMessage$49(message) {
  return "GetExecutionHistoryForSmartcut(" + (JSON.stringify(ExtensionMessaging__FromTab$SmartcutsMacros.MR_GetExecutionHistoryForSmartcut.getExecutionHistoryForSmartcut_encode(message._0)) + ")");
}

function stringifyResponse$49(response) {
  if (typeof response === "number") {
    return "NotLoggedIn";
  } else if (response.TAG === /* DidFindExecutionHistory */0) {
    return "DidFindExecutionHistory({executionHistory, exeuctionSets, unresolvedFailures, pendingExecutionSets})";
  } else {
    return "DidNotFindSmartcut(" + (response._0 + ")");
  }
}

var GetExecutionHistoryForSmartcut = {
  stringifyMessage: stringifyMessage$49,
  stringifyResponse: stringifyResponse$49
};

function stringifyMessage$50(message) {
  return "GetScheduledTriggersForSmartcut(" + message._0 + ")";
}

function stringifyResponse$50(response) {
  if (typeof response === "number") {
    return "NotLoggedIn";
  } else if (response.TAG === /* DidFindScheduledTriggers */0) {
    return "DidFindScheduledTriggers({executions, exeuctionSets, scheduledTriggers})";
  } else {
    return "DidNotFindSmartcut(" + (response._0 + ")");
  }
}

var GetScheduledTriggersForSmartcut = {
  stringifyMessage: stringifyMessage$50,
  stringifyResponse: stringifyResponse$50
};

function stringifyMessage$51(message) {
  return "FindExecutionById(" + (message._0 + ")");
}

function stringifyResponse$51(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "NotLoggedIn";
    } else {
      return "DidNotFindExecution";
    }
  } else {
    return "DidFindExecution(execution)";
  }
}

var FindExecutionById = {
  stringifyMessage: stringifyMessage$51,
  stringifyResponse: stringifyResponse$51
};

function stringifyMessage$52(message) {
  return "UpdateExecutionStatus(" + (message._0 + ", status)");
}

function stringifyResponse$52(response) {
  if (response) {
    return "NotLoggedIn";
  } else {
    return "DidUpdateExecutionStatus";
  }
}

var UpdateExecutionStatus = {
  stringifyMessage: stringifyMessage$52,
  stringifyResponse: stringifyResponse$52
};

function stringifyMessage$53(message) {
  return "UpsertExecutionSet(executionSet)";
}

function stringifyResponse$53(response) {
  return "DidUpsertExecutionSet(isPlayingBackAnotherExecutionSet: " + (Pervasives.string_of_bool(response._0) + ")");
}

var UpsertExecutionSet = {
  stringifyMessage: stringifyMessage$53,
  stringifyResponse: stringifyResponse$53
};

function stringifyMessage$54(message) {
  return "DeleteExecutionSet(" + (message._0 + ")");
}

function stringifyResponse$54(response) {
  if (response) {
    return "NotLoggedIn";
  } else {
    return "DidDeleteExecutionSet";
  }
}

var DeleteExecutionSet = {
  stringifyMessage: stringifyMessage$54,
  stringifyResponse: stringifyResponse$54
};

function stringifyMessage$55(message) {
  return "GetExecutionSetProgress";
}

function stringifyResponse$55(response) {
  if (response) {
    return "DidGetExecutionSetProgress(" + (ExtensionMessaging__FromTab$SmartcutsMacros.MR_GetExecutionSetProgress.stringifyProgress(response._0) + ")");
  } else {
    return "NotLoggedIn";
  }
}

var GetExecutionSetProgress = {
  stringifyMessage: stringifyMessage$55,
  stringifyResponse: stringifyResponse$55
};

function stringifyMessage$56(message) {
  return "GetExecutionSetById(" + message._0 + ")";
}

function stringifyResponse$56(response) {
  return ExtensionMessaging__FromTab$SmartcutsMacros.MR_GetExecutionSetById.stringifyResponse(response);
}

var GetExecutionSetById = {
  stringifyMessage: stringifyMessage$56,
  stringifyResponse: stringifyResponse$56
};

function stringifyMessage$57(message) {
  return "UpsertScheduledTriggerAndCreateAlarm(scheduledTrigger)";
}

function stringifyResponse$57(response) {
  switch (response) {
    case /* DidUpsertScheduledTriggerAndCreateAlarm */0 :
        return "DidUpsertScheduledTriggerAndCreateAlarm";
    case /* DidNotFindSmartcut */1 :
        return "DidNotFindSmartcut";
    case /* NotLoggedIn */2 :
        return "NotLoggedIn";
    
  }
}

var UpsertScheduledTriggerAndCreateAlarm = {
  stringifyMessage: stringifyMessage$57,
  stringifyResponse: stringifyResponse$57
};

function stringifyMessage$58(message) {
  return "ArchiveScheduledTrigger(" + (message._0 + ")");
}

function stringifyResponse$58(response) {
  switch (response) {
    case /* DidArchiveScheduledTrigger */0 :
        return "DidArchiveScheduledTrigger";
    case /* DidNotClearAlarmNorArchiveInDb */1 :
        return "DidNotClearAlarmNorArchiveInDb";
    case /* DidNotClearAlarmButDidArchiveInDb */2 :
        return "DidNotClearAlarmButDidArchiveInDb";
    case /* ClearedAlarmButDidNotArchiveInDb */3 :
        return "ClearedAlarmButDidNotArchiveInDb";
    case /* NotLoggedIn */4 :
        return "NotLoggedIn";
    
  }
}

var ArchiveScheduledTrigger = {
  stringifyMessage: stringifyMessage$58,
  stringifyResponse: stringifyResponse$58
};

function stringifyMessage$59(message) {
  return "SaveExternalAccount(_account)";
}

function stringifyResponse$59(response) {
  return "DidSaveExternalAccount";
}

var SaveExternalAccount = {
  stringifyMessage: stringifyMessage$59,
  stringifyResponse: stringifyResponse$59
};

function stringifyMessage$60(message) {
  return "FindExternalAccountById(" + (message._0 + ")");
}

function stringifyResponse$60(response) {
  if (response) {
    return "DidFindExternalAccount(account)";
  } else {
    return "DidNotFindExternalAccount";
  }
}

var FindExternalAccountById = {
  stringifyMessage: stringifyMessage$60,
  stringifyResponse: stringifyResponse$60
};

function stringifyMessage$61(message) {
  return "GetOAuthToken(" + (Pervasives.string_of_bool(message._0) + ")");
}

function stringifyResponse$61(response) {
  if (response) {
    return "DidGetOAuthToken(token)";
  } else {
    return "DidNotGetOAuthToken";
  }
}

var GetOAuthToken = {
  stringifyMessage: stringifyMessage$61,
  stringifyResponse: stringifyResponse$61
};

function stringifyMessage$62(message) {
  return "AskBgToWriteToClipboard(" + (ClipboardHelpers$SmartcutsMacros.stringifyTextOrImageResolved(message._0) + ")");
}

function stringifyResponse$62(response) {
  return "BgDidWriteToClipboard";
}

var AskBgToClipboard = {
  stringifyMessage: stringifyMessage$62,
  stringifyResponse: stringifyResponse$62
};

function stringifyMessage$63(message) {
  return "InitGoogleAuthFlow(" + (Modal__WebAuth$SmartcutsMacros.Context.stringify(message._0) + ")");
}

function stringifyResponse$63(response) {
  if (response) {
    return "GoogleAuthFlowDidGetOAuthToken(" + (response._0 + ")");
  } else {
    return "GoogleAuthFlowWasCanceledByUser";
  }
}

var InitGoogleAuthFlow = {
  stringifyMessage: stringifyMessage$63,
  stringifyResponse: stringifyResponse$63
};

function stringifyMessage$64(message) {
  return "UserDidCloseGoogleOAuthModal";
}

function stringifyResponse$64(response) {
  return "AckUserDidCloseGoogleOAuthModal";
}

var UserDidCloseGoogleOAuthModal = {
  stringifyMessage: stringifyMessage$64,
  stringifyResponse: stringifyResponse$64
};

function stringifyMessage$65(message) {
  if (typeof message === "number") {
    return "Cancel";
  }
  switch (message.TAG | 0) {
    case /* InitWithSmartcutId */0 :
        var match = message._0;
        return "InitWithSmartcutId({installedSmartcutId: " + (match.installedSmartcutId + (", tabId: " + (String(match.tabId) + "})")));
    case /* UpdateLinks */1 :
        return "UpdateLinks(array(length=" + (String(message._0.length) + "))");
    case /* UpdateLinkAtIndex */2 :
        return "UpdateLinkAtIndex(" + (String(message._0) + (", " + (MultiUrlTriggering__Shared$SmartcutsMacros.Link.stringify(DOM__HtmlElement$SmartcutsMacros.ForSerialization.stringify, message._1) + ")")));
    case /* SubmitForPlayback */3 :
        return "SubmitForPlayback(" + (JSON.stringify(ExtensionMessaging__FromTab$SmartcutsMacros.MR_MultiUrlTriggering.submitForPlayback_encode(message._0)) + ")");
    
  }
}

function stringifyResponse$65(response) {
  return "Ok";
}

function stringifyMessage$66(message) {
  if (typeof message === "number") {
    if (message === /* FetchCandidateChains */0) {
      return "FetchCandidateChains";
    } else {
      return "StopDebug";
    }
  } else if (message.TAG === /* GoToStep */0) {
    return "GoToStep(" + (String(message._0) + ")");
  } else {
    return "HighlightCandidateChain(" + (String(message._0) + ")");
  }
}

function stringifyResponse$66(response) {
  if (response) {
    return "DidFetchCandidateChains(candidateChains)";
  } else {
    return "Ok";
  }
}

var DebugSelector = {
  stringifyMessage: stringifyMessage$66,
  stringifyResponse: stringifyResponse$66
};

function stringifyMessage$67(message) {
  return "StopPlayback";
}

function stringifyResponse$67(response) {
  return "Ok";
}

var PlaybackModeControl = {
  stringifyMessage: stringifyMessage$67,
  stringifyResponse: stringifyResponse$67
};

function stringifyMessage$68(message) {
  return "AskBgToUpdateLinkGroups(size=" + (String(Belt_MapString.size(message._0)) + ")");
}

function stringifyResponse$68(response) {
  return "AckUpdateLinkGroups";
}

var UrlTriggering_AskBgToUpdateLinkGroups = {
  stringifyMessage: stringifyMessage$68,
  stringifyResponse: stringifyResponse$68
};

function stringifyMessage$69(message) {
  return "AskBgToRecordPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringifyPageAction(message._0) + ")");
}

function stringifyResponse$69(response) {
  return "AckAskBgToRecordPageAction";
}

var UrlTriggering_AskBgToRecordPageAction = {
  stringifyMessage: stringifyMessage$69,
  stringifyResponse: stringifyResponse$69
};

function stringifyMessage$70(message) {
  return "AskBgToStopRecordPageAction(" + (MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify(message._0) + ")");
}

function stringifyResponse$70(response) {
  return "AckAskBgToStopRecordPageAction";
}

var UrlTriggering_AskBgToStopRecordPageAction = {
  stringifyMessage: stringifyMessage$70,
  stringifyResponse: stringifyResponse$70
};

function stringifyMessage$71(message) {
  return "AskBgToUpdatePaginateFn(" + (MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify(message._0) + ")");
}

function stringifyResponse$71(response) {
  return "AckAskBgToUpdatePaginateFn";
}

var UrlTriggering_AskBgToUpdatePaginateFn = {
  stringifyMessage: stringifyMessage$71,
  stringifyResponse: stringifyResponse$71
};

function stringifyMessage$72(message) {
  return "AskBgToPlaybackPageActionUntil(" + (MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil(message._0) + ")");
}

function stringifyResponse$72(response) {
  return "AckAskBgToPlaybackPageAction";
}

var UrlTriggering_AskBgToPlaybackPageAction = {
  stringifyMessage: stringifyMessage$72,
  stringifyResponse: stringifyResponse$72
};

function stringifyMessage$73(message) {
  if (message) {
    return "AskBgToPlaybackPageActionFinished";
  } else {
    return "NotifyBgAboutToStartSinglePageAction";
  }
}

function stringifyResponse$73(response) {
  if (response) {
    return "AckAskBgToPlaybackPageActionFinished";
  } else {
    return "AckNotifyBgAboutToStartSinglePageAction";
  }
}

var UrlTriggering_DidFinishPlaybackPageAction$1 = {
  stringifyMessage: stringifyMessage$73,
  stringifyResponse: stringifyResponse$73
};

function stringifyMessage$74(message) {
  return "AskBgToShowLinkWithId(" + (message._0 + ")");
}

function stringifyResponse$74(response) {
  return "AckAskBgToShowLinkWithId";
}

var UrlTriggering_AskBgToShowLinkWithId = {
  stringifyMessage: stringifyMessage$74,
  stringifyResponse: stringifyResponse$74
};

function stringifyMessage$75(message) {
  return "AskBgToSaveUrlTriggeringAsSmartcut";
}

function stringifyResponse$75(response) {
  return "AckAskBgToSaveUrlTriggeringAsSmartcut";
}

var UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = {
  stringifyMessage: stringifyMessage$75,
  stringifyResponse: stringifyResponse$75
};

function stringifyMessage$76(message) {
  return "MaybeReadyToPlaybackPagination";
}

function stringifyResponse$76(response) {
  return "AckMaybeReadyToPlaybackPagination";
}

var UrlTriggering_MaybeReadyToPlaybackPagination = {
  stringifyMessage: stringifyMessage$76,
  stringifyResponse: stringifyResponse$76
};

function stringifyMessage$77(message) {
  return "AskBgToFocusTab(" + (String(message._0) + ")");
}

function stringifyResponse$77(response) {
  return "AckAskBgToFocusTab";
}

var AskBgToFocusTab = {
  stringifyMessage: stringifyMessage$77,
  stringifyResponse: stringifyResponse$77
};

function stringifyMessage$78(message) {
  return "AskBgToFocusWindow(" + (String(message._0) + ")");
}

function stringifyResponse$78(response) {
  return "AckAskBgToFocusWindow";
}

var AskBgToFocusWindow = {
  stringifyMessage: stringifyMessage$78,
  stringifyResponse: stringifyResponse$78
};

function stringifyMessage$79(message) {
  return "GetProgressBySmartcutId(" + message._0 + ")";
}

function stringifyResponse$79(response) {
  if (response) {
    return "Progress(" + (String(response._0) + ")");
  } else {
    return "ProgressNotFound";
  }
}

var SmartcutSavingProgress = {
  stringifyMessage: stringifyMessage$79,
  stringifyResponse: stringifyResponse$79
};

function stringifyMessage$80(message) {
  return "RequestPermissions(permissions, permissionTrigger)";
}

function stringifyResponse$80(response) {
  return "DidRequestPermissions";
}

var RequestPermissions = {
  stringifyMessage: stringifyMessage$80,
  stringifyResponse: stringifyResponse$80
};

function stringifyMessage$81(message) {
  if (message) {
    return "ConfirmedToRunFirstNExecutions(" + (String(message._0) + ")");
  } else {
    return "Canceled";
  }
}

function stringifyResponse$81(response) {
  return "AckConfirmExecutionQuotaResult";
}

var NotifyConfirmExecutionQuotaResult = {
  stringifyMessage: stringifyMessage$81,
  stringifyResponse: stringifyResponse$81
};

function stringifyMessage$82(message) {
  return "TrackWithSegment(event)";
}

function stringifyResponse$82(response) {
  return "BgDidTrackWithSegment";
}

var TrackWithSegment = {
  stringifyMessage: stringifyMessage$82,
  stringifyResponse: stringifyResponse$82
};

function stringifyMessage$83(message) {
  return "UserReadyLogInToWebsite";
}

function stringifyResponse$83(response) {
  return "AckUserReadyLogInToWebsite";
}

var UserReadyLogInToWebsite = {
  stringifyMessage: stringifyMessage$83,
  stringifyResponse: stringifyResponse$83
};

function stringifyMessage$84(message) {
  return "OpenNewWindow(" + (Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.MR_OpenNewWindow.Params.stringify, message._0) + ")");
}

function stringifyResponse$84(response) {
  return "AckOpenNewWindow";
}

var OpenNewWindow = {
  stringifyMessage: stringifyMessage$84,
  stringifyResponse: stringifyResponse$84
};

function stringifyMessage$85(message) {
  return "StoreAuthStatusItem(key=" + (message._0 + (", value=" + (message._1 + ")")));
}

function stringifyResponse$85(response) {
  return "AckStoreAuthStatusItem";
}

var StoreAuthStatusItem = {
  stringifyMessage: stringifyMessage$85,
  stringifyResponse: stringifyResponse$85
};

function stringifyMessage$86(message) {
  return "AskBgToHighlightElement(callback=" + (HighlightElement__Shared$SmartcutsMacros.Callback.stringify(message._0) + ")");
}

function stringifyResponse$86(response) {
  return "AckHighlightElement";
}

var AskBgToHighlightElement = {
  stringifyMessage: stringifyMessage$86,
  stringifyResponse: stringifyResponse$86
};

function stringifyMessage$87(message) {
  return "DidCloseExplainModalAndAskBgToHighlightElement(" + (Pervasives.string_of_bool(message._0) + ")");
}

function stringifyResponse$87(response) {
  return "AckDidCloseExplainModalAndAskBgToHighlightElement";
}

var DidCloseExplainModalAndAskBgToHighlightElement = {
  stringifyMessage: stringifyMessage$87,
  stringifyResponse: stringifyResponse$87
};

function stringifyMessage$88(message) {
  if (message) {
    return "PopupAskBgToStopHighlightElementOnTab(tabId=" + (String(message._0) + ")");
  } else {
    return "TabAskBgToStopHighlightElement";
  }
}

function stringifyResponse$88(response) {
  return "DidTeardownHighlightElementControl";
}

var AskBgToStopHighlightElement = {
  stringifyMessage: stringifyMessage$88,
  stringifyResponse: stringifyResponse$88
};

function stringifyMessage$89(message) {
  return "GetUserCredentials";
}

function stringifyResponse$89(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "VaultNotInitialized";
    } else {
      return "NotLoggedIn";
    }
  }
  var match = response._0;
  var vaultStatus = match.vaultStatus;
  return "DidGetUserCredentials({ credentials[size=" + (String(match.credentials.length) + ("], vaultStatus: " + ((
                typeof vaultStatus === "number" ? (
                    vaultStatus !== 0 ? "VaultLocked" : "VaultUnlocked"
                  ) : "HasAskedTabToUnlockVault(" + (String(vaultStatus._0) + ")")
              ) + " })")));
}

var GetUserCredentials = {
  stringifyMessage: stringifyMessage$89,
  stringifyResponse: stringifyResponse$89
};

function stringifyMessage$90(message) {
  return "UnlockVaultWithMasterSecret(masterSecret)";
}

function stringifyResponse$90(response) {
  if (!response) {
    return "DidUnlockVaultWithMasterSecret";
  }
  var error = response._0;
  var tmp;
  if (typeof error === "number") {
    switch (error) {
      case /* UserCredentialsNotInitialized */0 :
          tmp = "UserCredentialsNotInitialized";
          break;
      case /* IncorrectMasterSecret */1 :
          tmp = "IncorrectMasterSecret";
          break;
      case /* VaultNotInitialized */2 :
          tmp = "VaultNotInitialized";
          break;
      case /* DeccoDecodeError */3 :
          tmp = "DeccoDecodeError";
          break;
      case /* NotLoggedIn */4 :
          tmp = "NotLoggedIn";
          break;
      
    }
  } else {
    tmp = "KeyNotFound(" + (error._0 + ")");
  }
  return "DidNotUnlockVault(error=" + (tmp + ")");
}

var UnlockVaultWithMasterSecret = {
  stringifyMessage: stringifyMessage$90,
  stringifyResponse: stringifyResponse$90
};

function stringifyMessage$91(message) {
  return "ModifyUserCredentials({masterSecret: ********, action: " + (BgFx__UserCredentials__Shared$SmartcutsMacros.ModifyAction.stringify((function (param) {
                  return "";
                }), message._0.action) + "})");
}

function stringifyResponse$91(response) {
  if (response.TAG === /* DidModifyUserCredentials */0) {
    return "DidModifyUserCredentials(" + (response._0 + ")");
  }
  var reason = response._0;
  var tmp;
  if (typeof reason === "number") {
    switch (reason) {
      case /* IncorrectMasterSecret */0 :
          tmp = "IncorrectMasterSecret";
          break;
      case /* VaultNotInitialized */1 :
          tmp = "VaultNotInitialized";
          break;
      case /* VaultAlreadyExists */2 :
          tmp = "VaultAlreadyExists";
          break;
      case /* DeccoDecodeError */3 :
          tmp = "DeccoDecodeError";
          break;
      case /* NotLoggedIn */4 :
          tmp = "NotLoggedIn";
          break;
      
    }
  } else {
    switch (reason.TAG | 0) {
      case /* FaunaGraphqlError */0 :
          tmp = "FaunaGraphqlError(error)";
          break;
      case /* JsonDecodeError */1 :
          tmp = "JsonDecodeError(" + (reason._0 + ")");
          break;
      case /* KeyNotFound */2 :
          tmp = "KeyNotFound(" + (reason._0 + ")");
          break;
      
    }
  }
  return "DidNotModifyUserCredentials(reason=" + (tmp + ")");
}

var ModifyUserCredentials = {
  stringifyMessage: stringifyMessage$91,
  stringifyResponse: stringifyResponse$91
};

function stringifyMessage$92(message) {
  return "TabAskBgIfMasterSecretDoesExist";
}

function stringifyResponse$92(response) {
  if (response) {
    return "MasterSecretDoesNotExist";
  } else {
    return "MasterSecretDoesExist";
  }
}

var AskBgIfMasterSecretDoesExist = {
  stringifyMessage: stringifyMessage$92,
  stringifyResponse: stringifyResponse$92
};

function stringifyMessage$93(message) {
  return "TabAskBgForMissingPasswords";
}

function stringifyResponse$93(response) {
  if (response) {
    return "MissingPasswords([...passwordIDs])";
  } else {
    return "NoMissingPasswords";
  }
}

var AskBgForMissingPasswords = {
  stringifyMessage: stringifyMessage$93,
  stringifyResponse: stringifyResponse$93
};

function stringifyMessage$94(message) {
  return "AskBgToResetMasterSecret(masterSecret)";
}

function stringifyResponse$94(response) {
  if (response) {
    return "DidResetMasterSecret(" + (response._0 + ")");
  } else {
    return "DidResetMasterSecret";
  }
}

var AskBgToResetMasterSecret = {
  stringifyMessage: stringifyMessage$94,
  stringifyResponse: stringifyResponse$94
};

function stringifyMessage$95(message) {
  return "AskBgToDetachLoginSmartcut(masterSecret)";
}

function stringifyResponse$95(response) {
  if (!response) {
    return "DidDetachLoginSmartcut";
  }
  var reason = response._0;
  return "DidDetachLoginSmartcut(" + ((
            typeof reason === "number" ? (
                reason !== 0 ? "CouldNotFindSmartcut" : "NotLoggedIn"
              ) : "FaunaGraphqlError(error)"
          ) + ")");
}

var AskBgToDetachLoginSmartcut = {
  stringifyMessage: stringifyMessage$95,
  stringifyResponse: stringifyResponse$95
};

function stringifyMessage$96(message) {
  return "AskBgToEnterDataExtractionMode";
}

function stringifyResponse$96(response) {
  if (response) {
    return "BgCouldNotFindActiveTab";
  } else {
    return "DidEnterDataExtractionMode";
  }
}

var AskBgToEnterDataExtractionMode = {
  stringifyMessage: stringifyMessage$96,
  stringifyResponse: stringifyResponse$96
};

function stringifyMessage$97(message) {
  return "AskBgToProcessDataExtractionSignal(STEM(signal))";
}

function stringifyResponse$97(response) {
  return "DidProcessDataExtractionSignal(STEM(output))";
}

var AskBgToProcessDataExtractionSignal = {
  stringifyMessage: stringifyMessage$97,
  stringifyResponse: stringifyResponse$97
};

function stringifyMessage$98(message) {
  return "AskBgToCreateVaultWithMasterSecret(masterSecret)";
}

function stringifyResponse$98(response) {
  if (!response) {
    return "DidCreateVaultWithMasterSecret";
  }
  var reason = response._0;
  var tmp;
  if (typeof reason === "object") {
    var variant = reason.NAME;
    tmp = variant === "DeccoDecodeError" ? "DeccoDecodeError(error)" : (
        variant === "JsonDecodeError" ? "JsonDecodeError(" + (reason.VAL + ")") : "FaunaGraphqlError(error)"
      );
  } else {
    tmp = reason === "VaultNotInitialized" ? "VaultNotInitialized" : (
        reason === "IncorrectMasterSecret" ? "IncorrectMasterSecret" : "VaultAlreadyExists"
      );
  }
  return "DidNotCreateVaultWithMasterSecret(reason=" + (tmp + ")");
}

var AskBgToCreateVaultWithMasterSecret = {
  stringifyMessage: stringifyMessage$98,
  stringifyResponse: stringifyResponse$98
};

function stringifyMessage$99(message) {
  return "CreateSpreadsheet(" + (message._0.title + ", sheets)");
}

function stringifyResponse$99(response) {
  if (typeof response !== "number") {
    return "DidCreateSpreadsheet(spreadsheet)";
  }
  switch (response) {
    case /* DidNotCreateSpreadsheet */0 :
        return "DidNotCreateSpreadsheet";
    case /* DidNotCreateSpreadsheetBecauseUnauthenticated */1 :
        return "DidNotCreateSpreadsheetBecauseUnauthenticated";
    case /* DidNotCreateSpreadsheetBecauseGapiNotLoaded */2 :
        return "DidNotCreateSpreadsheetBecauseGapiNotLoaded";
    
  }
}

var CreateGoogleSheet = {
  stringifyMessage: stringifyMessage$99,
  stringifyResponse: stringifyResponse$99
};

function stringifyMessage$100(message) {
  return "FetchGoogleSheet(" + (message._0.spreadsheetId + ")");
}

function stringifyResponse$100(response) {
  if (typeof response !== "number") {
    return "DidFetchGoogleSheet(spreadsheet)";
  }
  switch (response) {
    case /* DidNotFetchGoogleSheet */0 :
        return "DidNotFetchGoogleSheet";
    case /* DidNotFetchGoogleSheetBecauseUnauthenticated */1 :
        return "DidNotFetchGoogleSheetBecauseUnauthenticated";
    case /* DidNotFetchGoogleSheetBecauseGapiNotLoaded */2 :
        return "DidNotFetchGoogleSheetBecauseGapiNotLoaded";
    
  }
}

var FetchGoogleSheet = {
  stringifyMessage: stringifyMessage$100,
  stringifyResponse: stringifyResponse$100
};

function stringifyMessage$101(message) {
  return "BatchUpdateSpreadsheet({" + (message._0.spreadsheetId + ", requestBody})");
}

function stringifyResponse$101(response) {
  switch (response) {
    case /* DidBatchUpdateSpreadsheet */0 :
        return "DidBatchUpdateSpreadsheet";
    case /* DidNotBatchUpdateSpreadsheet */1 :
        return "DidNotBatchUpdateSpreadsheet";
    case /* DidNotBatchUpdateSpreadsheetBecauseUnauthenticated */2 :
        return "DidNotBatchUpdateSpreadsheetBecauseUnauthenticated";
    case /* DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded */3 :
        return "DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded";
    
  }
}

var BatchUpdateGoogleSheet = {
  stringifyMessage: stringifyMessage$101,
  stringifyResponse: stringifyResponse$101
};

function stringifyMessage$102(message) {
  return "AskBgToExitFromDataExtractionMode";
}

function stringifyResponse$102(response) {
  return "DidExitFromDataExtractionMode";
}

var AskBgToExitFromDataExtractionMode = {
  stringifyMessage: stringifyMessage$102,
  stringifyResponse: stringifyResponse$102
};

function stringifyMessage$103(message) {
  return "AskBgToRenderNotification(" + (RenderOnHost__Notification$SmartcutsMacros.stringify(message._0) + ")");
}

function stringifyResponse$103(response) {
  return "DidRenderNotification";
}

var AskBgToRenderNotification = {
  stringifyMessage: stringifyMessage$103,
  stringifyResponse: stringifyResponse$103
};

function stringifyMessage$104(message) {
  return "SaveDataExtractionAsSmartcut(" + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, message._0) + ", contextLocal)");
}

function stringifyResponse$104(response) {
  return "AckSaveDataExtractionAsSmartcut";
}

var AskBgToSaveDataExtractionAsSmartcut = {
  stringifyMessage: stringifyMessage$104,
  stringifyResponse: stringifyResponse$104
};

function stringifyMessage$105(message) {
  switch (message.TAG | 0) {
    case /* Message_ContentScriptReady */0 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ContentScriptReady.stringifyMessage, message._0);
    case /* Message_AskBgToRefreshAuthStatus */1 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRefreshAuthStatus.stringifyMessage, message._0);
    case /* Message_AskBgToFetchPlanSubscriptionProgress */2 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFetchPlanSubscriptionProgress.stringifyMessage, message._0);
    case /* Message_StartDebugSelector */3 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StartDebugSelector.stringifyMessage, message._0);
    case /* Message_StartRecording */4 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StartRecording.stringifyMessage, message._0);
    case /* Message_StopRecording */5 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StopRecording.stringifyMessage, message._0);
    case /* Message_DidStartRecording */6 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DidStartRecording.stringifyMessage, message._0);
    case /* Message_NotifyBgAboutPossibleCommand */7 :
        return Curry._1(ExtensionMessagingLogging.FromTab.NotifyBgAboutPossibleCommand.stringifyMessage, message._0);
    case /* Message_ClearKeyThatDoesNotGenerateCommand */8 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ClearKeyThatDoesNotGenerateCommand.stringifyMessage, message._0);
    case /* Message_RecordCommand */9 :
        return Curry._1(ExtensionMessagingLogging.FromTab.RecordCommand.stringifyMessage, message._0);
    case /* Message_FinishAuthoring */10 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FinishAuthoring.stringifyMessage, message._0);
    case /* Message_OpenPageForSmartcutId */11 :
        return Curry._1(ExtensionMessagingLogging.FromTab.OpenPageForSmartcutId.stringifyMessage, message._0);
    case /* Message_ShowFormForSmartcutId */12 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ShowFormForSmartcutId.stringifyMessage, message._0);
    case /* Message_AskBgToAdjustModalGeometry */13 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToAdjustModalGeometry.stringifyMessage, message._0);
    case /* Message_InitializePlayback */14 :
        return Curry._1(ExtensionMessagingLogging.FromTab.InitializePlayback.stringifyMessage, message._0);
    case /* Message_GetAuthoringCommandLog */15 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetAuthoringCommandLog.stringifyMessage, message._0);
    case /* Message_GetSmartcut */16 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetSmartcut.stringifyMessage, message._0);
    case /* Message_GetMySmartcuts */17 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetMySmartcuts.stringifyMessage, message._0);
    case /* Message_InstallSmartcut */18 :
        return Curry._1(ExtensionMessagingLogging.FromTab.InstallSmartcut.stringifyMessage, message._0);
    case /* Message_DeleteSmartcut */19 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DeleteSmartcut.stringifyMessage, message._0);
    case /* Message_GetExecutionHistoryForSmartcut */20 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionHistoryForSmartcut.stringifyMessage, message._0);
    case /* Message_GetScheduledTriggersForSmartcut */21 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetScheduledTriggersForSmartcut.stringifyMessage, message._0);
    case /* Message_FindExecutionById */22 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FindExecutionById.stringifyMessage, message._0);
    case /* Message_UpdateExecutionStatus */23 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UpdateExecutionStatus.stringifyMessage, message._0);
    case /* Message_UpsertExecutionSet */24 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UpsertExecutionSet.stringifyMessage, message._0);
    case /* Message_DeleteExecutionSet */25 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DeleteExecutionSet.stringifyMessage, message._0);
    case /* Message_GetExecutionSetProgress */26 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetProgress.stringifyMessage, message._0);
    case /* Message_GetExecutionSetById */27 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetById.stringifyMessage, message._0);
    case /* Message_UpsertScheduledTriggerAndCreateAlarm */28 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UpsertScheduledTriggerAndCreateAlarm.stringifyMessage, message._0);
    case /* Message_ArchiveScheduledTrigger */29 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ArchiveScheduledTrigger.stringifyMessage, message._0);
    case /* Message_SaveExternalAccount */30 :
        return Curry._1(ExtensionMessagingLogging.FromTab.SaveExternalAccount.stringifyMessage, message._0);
    case /* Message_FindExternalAccountById */31 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FindExternalAccountById.stringifyMessage, message._0);
    case /* Message_GetOAuthToken */32 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetOAuthToken.stringifyMessage, message._0);
    case /* Message_AskBgToClipboard */33 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToClipboard.stringifyMessage, message._0);
    case /* Message_CreateGoogleSheet */34 :
        return Curry._1(ExtensionMessagingLogging.FromTab.CreateGoogleSheet.stringifyMessage, message._0);
    case /* Message_FetchGoogleSheet */35 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FetchGoogleSheet.stringifyMessage, message._0);
    case /* Message_BatchUpdateGoogleSheet */36 :
        return Curry._1(ExtensionMessagingLogging.FromTab.BatchUpdateGoogleSheet.stringifyMessage, message._0);
    case /* Message_InitGoogleAuthFlow */37 :
        return Curry._1(ExtensionMessagingLogging.FromTab.InitGoogleAuthFlow.stringifyMessage, message._0);
    case /* Message_UserDidCloseGoogleOAuthModal */38 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UserDidCloseGoogleOAuthModal.stringifyMessage, message._0);
    case /* Message_MultiUrlTriggering */39 :
        return Curry._1(ExtensionMessagingLogging.FromTab.MultiUrlTriggering.stringifyMessage, message._0);
    case /* Message_DebugSelector */40 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DebugSelector.stringifyMessage, message._0);
    case /* Message_PlaybackModeControl */41 :
        return Curry._1(ExtensionMessagingLogging.FromTab.PlaybackModeControl.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToUpdateLinkGroups */42 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdateLinkGroups.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToRecordPageAction */43 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToRecordPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToStopRecordPageAction */44 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToStopRecordPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToUpdatePaginateFn */45 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdatePaginateFn.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToPlaybackPageAction */46 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToPlaybackPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_DidFinishPlaybackPageAction */47 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_DidFinishPlaybackPageAction.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToShowLinkWithId */48 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToShowLinkWithId.stringifyMessage, message._0);
    case /* Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut.stringifyMessage, message._0);
    case /* Message_UrlTriggering_MaybeReadyToPlaybackPagination */50 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_MaybeReadyToPlaybackPagination.stringifyMessage, message._0);
    case /* Message_AskBgToFocusTab */51 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusTab.stringifyMessage, message._0);
    case /* Message_AskBgToFocusWindow */52 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusWindow.stringifyMessage, message._0);
    case /* Message_SmartcutSavingProgress */53 :
        return Curry._1(ExtensionMessagingLogging.FromTab.SmartcutSavingProgress.stringifyMessage, message._0);
    case /* Message_RequestPermissions */54 :
        return Curry._1(ExtensionMessagingLogging.FromTab.RequestPermissions.stringifyMessage, message._0);
    case /* Message_NotifyConfirmExecutionQuotaResult */55 :
        return Curry._1(ExtensionMessagingLogging.FromTab.NotifyConfirmExecutionQuotaResult.stringifyMessage, message._0);
    case /* Message_TrackWithSegment */56 :
        return Curry._1(ExtensionMessagingLogging.FromTab.TrackWithSegment.stringifyMessage, message._0);
    case /* Message_UserReadyLogInToWebsite */57 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UserReadyLogInToWebsite.stringifyMessage, message._0);
    case /* Message_OpenNewWindow */58 :
        return Curry._1(ExtensionMessagingLogging.FromTab.OpenNewWindow.stringifyMessage, message._0);
    case /* Message_StoreAuthStatusItem */59 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StoreAuthStatusItem.stringifyMessage, message._0);
    case /* Message_AskBgToHighlightElement */60 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToHighlightElement.stringifyMessage, message._0);
    case /* Message_DidCloseExplainModalAndAskBgToHighlightElement */61 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DidCloseExplainModalAndAskBgToHighlightElement.stringifyMessage, message._0);
    case /* Message_AskBgToStopHighlightElement */62 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToStopHighlightElement.stringifyMessage, message._0);
    case /* Message_GetUserCredentials */63 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetUserCredentials.stringifyMessage, message._0);
    case /* Message_UnlockVaultWithMasterSecret */64 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UnlockVaultWithMasterSecret.stringifyMessage, message._0);
    case /* Message_ModifyUserCredentials */65 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ModifyUserCredentials.stringifyMessage, message._0);
    case /* Message_AskBgIfMasterSecretDoesExist */66 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgIfMasterSecretDoesExist.stringifyMessage, message._0);
    case /* Message_AskBgForMissingPasswords */67 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgForMissingPasswords.stringifyMessage, message._0);
    case /* Message_AskBgToCreateVaultWithMasterSecret */68 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToCreateVaultWithMasterSecret.stringifyMessage, message._0);
    case /* Message_AskBgToResetMasterSecret */69 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToResetMasterSecret.stringifyMessage, message._0);
    case /* Message_AskBgToDetachLoginSmartcut */70 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToDetachLoginSmartcut.stringifyMessage, message._0);
    case /* Message_AskBgToEnterDataExtractionMode */71 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToEnterDataExtractionMode.stringifyMessage, message._0);
    case /* Message_AskBgToProcessDataExtractionSignal */72 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToProcessDataExtractionSignal.stringifyMessage, message._0);
    case /* Message_AskBgToExitFromDataExtractionMode */73 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToExitFromDataExtractionMode.stringifyMessage, message._0);
    case /* Message_AskBgToSaveDataExtractionAsSmartcut */74 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToSaveDataExtractionAsSmartcut.stringifyMessage, message._0);
    case /* Message_AskBgToRenderNotification */75 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRenderNotification.stringifyMessage, message._0);
    
  }
}

function stringifyResponse$105(response) {
  switch (response.TAG | 0) {
    case /* Response_ContentScriptReady */0 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ContentScriptReady.stringifyResponse, response._0);
    case /* Response_AskBgToRefreshAuthStatus */1 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRefreshAuthStatus.stringifyResponse, response._0);
    case /* Response_AskBgToFetchPlanSubscriptionProgress */2 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFetchPlanSubscriptionProgress.stringifyResponse, response._0);
    case /* Response_StartDebugSelector */3 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StartDebugSelector.stringifyResponse, response._0);
    case /* Response_StartRecording */4 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StartRecording.stringifyResponse, response._0);
    case /* Response_StopRecording */5 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StopRecording.stringifyResponse, response._0);
    case /* Response_DidStartRecording */6 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DidStartRecording.stringifyResponse, response._0);
    case /* Response_NotifyBgAboutPossibleCommand */7 :
        return Curry._1(ExtensionMessagingLogging.FromTab.NotifyBgAboutPossibleCommand.stringifyResponse, response._0);
    case /* Response_ClearKeyThatDoesNotGenerateCommand */8 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ClearKeyThatDoesNotGenerateCommand.stringifyResponse, response._0);
    case /* Response_RecordCommand */9 :
        return Curry._1(ExtensionMessagingLogging.FromTab.RecordCommand.stringifyResponse, response._0);
    case /* Response_FinishAuthoring */10 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FinishAuthoring.stringifyResponse, response._0);
    case /* Response_OpenPageForSmartcutId */11 :
        return Curry._1(ExtensionMessagingLogging.FromTab.OpenPageForSmartcutId.stringifyResponse, response._0);
    case /* Response_ShowFormForSmartcutId */12 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ShowFormForSmartcutId.stringifyResponse, response._0);
    case /* Response_AskBgToAdjustModalGeometry */13 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToAdjustModalGeometry.stringifyResponse, response._0);
    case /* Response_InitializePlayback */14 :
        return Curry._1(ExtensionMessagingLogging.FromTab.InitializePlayback.stringifyResponse, response._0);
    case /* Response_GetAuthoringCommandLog */15 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetAuthoringCommandLog.stringifyResponse, response._0);
    case /* Response_GetSmartcut */16 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetSmartcut.stringifyResponse, response._0);
    case /* Response_GetMySmartcuts */17 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetMySmartcuts.stringifyResponse, response._0);
    case /* Response_InstallSmartcut */18 :
        return Curry._1(ExtensionMessagingLogging.FromTab.InstallSmartcut.stringifyResponse, response._0);
    case /* Response_DeleteSmartcut */19 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DeleteSmartcut.stringifyResponse, response._0);
    case /* Response_GetExecutionHistoryForSmartcut */20 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionHistoryForSmartcut.stringifyResponse, response._0);
    case /* Response_GetScheduledTriggersForSmartcut */21 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetScheduledTriggersForSmartcut.stringifyResponse, response._0);
    case /* Response_FindExecutionById */22 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FindExecutionById.stringifyResponse, response._0);
    case /* Response_UpdateExecutionStatus */23 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UpdateExecutionStatus.stringifyResponse, response._0);
    case /* Response_UpsertExecutionSet */24 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UpsertExecutionSet.stringifyResponse, response._0);
    case /* Response_DeleteExecutionSet */25 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DeleteExecutionSet.stringifyResponse, response._0);
    case /* Response_GetExecutionSetProgress */26 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetProgress.stringifyResponse, response._0);
    case /* Response_GetExecutionSetById */27 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetExecutionSetById.stringifyResponse, response._0);
    case /* Response_UpsertScheduledTriggerAndCreateAlarm */28 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UpsertScheduledTriggerAndCreateAlarm.stringifyResponse, response._0);
    case /* Response_ArchiveScheduledTrigger */29 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ArchiveScheduledTrigger.stringifyResponse, response._0);
    case /* Response_SaveExternalAccount */30 :
        return Curry._1(ExtensionMessagingLogging.FromTab.SaveExternalAccount.stringifyResponse, response._0);
    case /* Response_FindExternalAccountById */31 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FindExternalAccountById.stringifyResponse, response._0);
    case /* Response_GetOAuthToken */32 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetOAuthToken.stringifyResponse, response._0);
    case /* Response_AskBgToClipboard */33 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToClipboard.stringifyResponse, response._0);
    case /* Response_CreateGoogleSheet */34 :
        return Curry._1(ExtensionMessagingLogging.FromTab.CreateGoogleSheet.stringifyResponse, response._0);
    case /* Response_FetchGoogleSheet */35 :
        return Curry._1(ExtensionMessagingLogging.FromTab.FetchGoogleSheet.stringifyResponse, response._0);
    case /* Response_BatchUpdateGoogleSheet */36 :
        return Curry._1(ExtensionMessagingLogging.FromTab.BatchUpdateGoogleSheet.stringifyResponse, response._0);
    case /* Response_InitGoogleAuthFlow */37 :
        return Curry._1(ExtensionMessagingLogging.FromTab.InitGoogleAuthFlow.stringifyResponse, response._0);
    case /* Response_UserDidCloseGoogleOAuthModal */38 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UserDidCloseGoogleOAuthModal.stringifyResponse, response._0);
    case /* Response_MultiUrlTriggering */39 :
        return Curry._1(ExtensionMessagingLogging.FromTab.MultiUrlTriggering.stringifyResponse, response._0);
    case /* Response_DebugSelector */40 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DebugSelector.stringifyResponse, response._0);
    case /* Response_PlaybackModeControl */41 :
        return Curry._1(ExtensionMessagingLogging.FromTab.PlaybackModeControl.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToUpdateLinkGroups */42 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdateLinkGroups.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToRecordPageAction */43 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToRecordPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToStopRecordPageAction */44 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToStopRecordPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToUpdatePaginateFn */45 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToUpdatePaginateFn.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToPlaybackPageAction */46 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToPlaybackPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_DidFinishPlaybackPageAction */47 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_DidFinishPlaybackPageAction.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToShowLinkWithId */48 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToShowLinkWithId.stringifyResponse, response._0);
    case /* Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut.stringifyResponse, response._0);
    case /* Response_UrlTriggering_MaybeReadyToPlaybackPagination */50 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UrlTriggering_MaybeReadyToPlaybackPagination.stringifyResponse, response._0);
    case /* Response_SmartcutSavingProgress */51 :
        return Curry._1(ExtensionMessagingLogging.FromTab.SmartcutSavingProgress.stringifyResponse, response._0);
    case /* Response_AskBgToFocusTab */52 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusTab.stringifyResponse, response._0);
    case /* Response_AskBgToFocusWindow */53 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToFocusWindow.stringifyResponse, response._0);
    case /* Response_RequestPermissions */54 :
        return Curry._1(ExtensionMessagingLogging.FromTab.RequestPermissions.stringifyResponse, response._0);
    case /* Response_NotifyConfirmExecutionQuotaResult */55 :
        return Curry._1(ExtensionMessagingLogging.FromTab.NotifyConfirmExecutionQuotaResult.stringifyResponse, response._0);
    case /* Response_TrackWithSegment */56 :
        return Curry._1(ExtensionMessagingLogging.FromTab.TrackWithSegment.stringifyResponse, response._0);
    case /* Response_UserReadyLogInToWebsite */57 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UserReadyLogInToWebsite.stringifyResponse, response._0);
    case /* Response_OpenNewWindow */58 :
        return Curry._1(ExtensionMessagingLogging.FromTab.OpenNewWindow.stringifyResponse, response._0);
    case /* Response_StoreAuthStatusItem */59 :
        return Curry._1(ExtensionMessagingLogging.FromTab.StoreAuthStatusItem.stringifyResponse, response._0);
    case /* Response_AskBgToHighlightElement */60 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToHighlightElement.stringifyResponse, response._0);
    case /* Response_DidCloseExplainModalAndAskBgToHighlightElement */61 :
        return Curry._1(ExtensionMessagingLogging.FromTab.DidCloseExplainModalAndAskBgToHighlightElement.stringifyResponse, response._0);
    case /* Response_AskBgToStopHighlightElement */62 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToStopHighlightElement.stringifyResponse, response._0);
    case /* Response_GetUserCredentials */63 :
        return Curry._1(ExtensionMessagingLogging.FromTab.GetUserCredentials.stringifyResponse, response._0);
    case /* Response_UnlockVaultWithMasterSecret */64 :
        return Curry._1(ExtensionMessagingLogging.FromTab.UnlockVaultWithMasterSecret.stringifyResponse, response._0);
    case /* Response_ModifyUserCredentials */65 :
        return Curry._1(ExtensionMessagingLogging.FromTab.ModifyUserCredentials.stringifyResponse, response._0);
    case /* Response_AskBgIfMasterSecretDoesExist */66 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgIfMasterSecretDoesExist.stringifyResponse, response._0);
    case /* Response_AskBgForMissingPasswords */67 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgForMissingPasswords.stringifyResponse, response._0);
    case /* Response_AskBgToCreateVaultWithMasterSecret */68 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToCreateVaultWithMasterSecret.stringifyResponse, response._0);
    case /* Response_AskBgToResetMasterSecret */69 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToResetMasterSecret.stringifyResponse, response._0);
    case /* Response_AskBgToDetachLoginSmartcut */70 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToDetachLoginSmartcut.stringifyResponse, response._0);
    case /* Response_AskBgToEnterDataExtractionMode */71 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToEnterDataExtractionMode.stringifyResponse, response._0);
    case /* Response_AskBgToProcessDataExtractionSignal */72 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToProcessDataExtractionSignal.stringifyResponse, response._0);
    case /* Response_AskBgToExitFromDataExtractionMode */73 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToExitFromDataExtractionMode.stringifyResponse, response._0);
    case /* Response_AskBgToSaveDataExtractionAsSmartcut */74 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToSaveDataExtractionAsSmartcut.stringifyResponse, response._0);
    case /* Response_AskBgToRenderNotification */75 :
        return Curry._1(ExtensionMessagingLogging.FromTab.AskBgToRenderNotification.stringifyResponse, response._0);
    
  }
}

var All$1 = {
  stringifyMessage: stringifyMessage$105,
  stringifyResponse: stringifyResponse$105
};

function stringifyMessage$106(message) {
  if (message.TAG !== /* Message_FromTabWithStateMachineDeps */0) {
    return stringifyMessage$105(message._0);
  }
  var msg = message._0;
  if (msg.TAG === /* Message_NotifyBgOfContentScriptFailure */0) {
    return stringifyMessage$30(msg._0);
  } else {
    return stringifyMessage$31(msg._0);
  }
}

function stringifyResponse$106(response) {
  if (response.TAG === /* Response_FromTabWithStateMachineDeps */0) {
    if (response._0.TAG === /* Response_NotifyBgOfContentScriptFailure */0) {
      return "BgDidAckTabError";
    } else {
      return "BgDidAckNotifyBgOfContentScriptResponseFailure";
    }
  } else {
    return stringifyResponse$105(response._0);
  }
}

var AllAll = {
  stringifyMessage: stringifyMessage$106,
  stringifyResponse: stringifyResponse$106
};

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StartStreamingEventsToBackground"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StopStreamingEventsToBackground"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "Playback"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "PlaybackExited"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "RenderInContentScript"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskContentScriptToAdjustModalGeometry"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskContentScriptToEnterUrlTriggeringMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_RefreshLinks"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_UpdateLinks"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_TellTabToUpdateLinkGroups"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_Exit"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskContentScriptToRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_StopRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_PlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_DidFinishPlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_ShowLinkWithId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_SendContextLocalAndLinkGroups"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_PrepareForScreenshot"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "PingTab"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DoesElementExistOnPage"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToRenderModalToExplainHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToSetupHighlightElementControl"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToTeardownHighlightElementControl"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToEnterDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskTabToExitDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "All"
              ]
            ]
          },
          "FromExtension"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ContentScriptReady"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToRefreshAuthStatus"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToFetchPlanSubscriptionProgress"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyBgOfContentScriptFailure"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyBgOfContentScriptResponseFailure"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StartDebugSelector"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StartRecording"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StopRecording"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DidStartRecording"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyBgAboutPossibleCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ClearKeyThatDoesNotGenerateCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "RecordCommand"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FinishAuthoring"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "OpenPageForSmartcutId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ShowFormForSmartcutId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToAdjustModalGeometry"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "InitializePlayback"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetAuthoringCommandLog"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetMySmartcuts"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "InstallSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DeleteSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetExecutionHistoryForSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetScheduledTriggersForSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FindExecutionById"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UpdateExecutionStatus"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UpsertExecutionSet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DeleteExecutionSet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetExecutionSetProgress"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetExecutionSetById"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UpsertScheduledTriggerAndCreateAlarm"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ArchiveScheduledTrigger"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "SaveExternalAccount"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FindExternalAccountById"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetOAuthToken"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToClipboard"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "CreateGoogleSheet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "FetchGoogleSheet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "BatchUpdateGoogleSheet"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "InitGoogleAuthFlow"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UserDidCloseGoogleOAuthModal"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "MultiUrlTriggering"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DebugSelector"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "PlaybackModeControl"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToUpdateLinkGroups"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToStopRecordPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToPlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_DidFinishPlaybackPageAction"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToShowLinkWithId"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_MaybeReadyToPlaybackPagination"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UrlTriggering_AskBgToUpdatePaginateFn"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToFocusTab"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToFocusWindow"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "SmartcutSavingProgress"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "RequestPermissions"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "NotifyConfirmExecutionQuotaResult"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "TrackWithSegment"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UserReadyLogInToWebsite"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "OpenNewWindow"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "StoreAuthStatusItem"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "DidCloseExplainModalAndAskBgToHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToStopHighlightElement"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "GetUserCredentials"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "UnlockVaultWithMasterSecret"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "ModifyUserCredentials"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgIfMasterSecretDoesExist"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgForMissingPasswords"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToCreateVaultWithMasterSecret"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToResetMasterSecret"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToDetachLoginSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToEnterDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToProcessDataExtractionSignal"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToExitFromDataExtractionMode"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToRenderNotification"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AskBgToSaveDataExtractionAsSmartcut"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "All"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "stringifyMessage"
                    ],
                    [
                      /* Function */0,
                      "stringifyResponse"
                    ]
                  ]
                },
                "AllAll"
              ]
            ]
          },
          "FromTab"
        ]
      ]
    }, ExtensionMessagingLogging, {
      FromExtension: {
        StartStreamingEventsToBackground: StartStreamingEventsToBackground,
        StopStreamingEventsToBackground: StopStreamingEventsToBackground,
        Playback: Playback,
        PlaybackExited: PlaybackExited,
        RenderInContentScript: RenderInContentScript,
        AskContentScriptToAdjustModalGeometry: AskContentScriptToAdjustModalGeometry,
        AskContentScriptToEnterUrlTriggeringMode: AskContentScriptToEnterUrlTriggeringMode,
        UrlTriggering_RefreshLinks: UrlTriggering_RefreshLinks,
        UrlTriggering_UpdateLinks: UrlTriggering_UpdateLinks,
        UrlTriggering_TellTabToUpdateLinkGroups: UrlTriggering_TellTabToUpdateLinkGroups,
        UrlTriggering_Exit: UrlTriggering_Exit,
        UrlTriggering_AskContentScriptToRecordPageAction: UrlTriggering_AskContentScriptToRecordPageAction,
        UrlTriggering_StopRecordPageAction: UrlTriggering_StopRecordPageAction,
        UrlTriggering_PlaybackPageAction: UrlTriggering_PlaybackPageAction,
        UrlTriggering_DidFinishPlaybackPageAction: UrlTriggering_DidFinishPlaybackPageAction,
        UrlTriggering_ShowLinkWithId: UrlTriggering_ShowLinkWithId,
        UrlTriggering_SendContextLocalAndLinkGroups: UrlTriggering_SendContextLocalAndLinkGroups,
        UrlTriggering_PrepareForScreenshot: UrlTriggering_PrepareForScreenshot,
        PingTab: PingTab,
        DoesElementExistOnPage: DoesElementExistOnPage,
        AskTabToRenderModalToExplainHighlightElement: AskTabToRenderModalToExplainHighlightElement,
        AskTabToSetupHighlightElementControl: AskTabToSetupHighlightElementControl,
        AskTabToTeardownHighlightElementControl: AskTabToTeardownHighlightElementControl,
        AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand: AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand,
        AskTabToEnterDataExtractionMode: AskTabToEnterDataExtractionMode,
        AskTabToExitDataExtractionMode: AskTabToExitDataExtractionMode,
        All: All
      },
      FromTab: {
        ContentScriptReady: ContentScriptReady,
        AskBgToRefreshAuthStatus: AskBgToRefreshAuthStatus,
        AskBgToFetchPlanSubscriptionProgress: AskBgToFetchPlanSubscriptionProgress,
        NotifyBgOfContentScriptFailure: NotifyBgOfContentScriptFailure,
        NotifyBgOfContentScriptResponseFailure: NotifyBgOfContentScriptResponseFailure,
        StartDebugSelector: StartDebugSelector,
        StartRecording: StartRecording,
        StopRecording: StopRecording,
        DidStartRecording: DidStartRecording,
        NotifyBgAboutPossibleCommand: NotifyBgAboutPossibleCommand,
        ClearKeyThatDoesNotGenerateCommand: ClearKeyThatDoesNotGenerateCommand,
        RecordCommand: RecordCommand,
        FinishAuthoring: FinishAuthoring,
        OpenPageForSmartcutId: OpenPageForSmartcutId,
        ShowFormForSmartcutId: ShowFormForSmartcutId,
        AskBgToAdjustModalGeometry: AskBgToAdjustModalGeometry,
        InitializePlayback: InitializePlayback,
        GetAuthoringCommandLog: GetAuthoringCommandLog,
        GetSmartcut: GetSmartcut,
        GetMySmartcuts: GetMySmartcuts,
        InstallSmartcut: InstallSmartcut,
        DeleteSmartcut: DeleteSmartcut,
        GetExecutionHistoryForSmartcut: GetExecutionHistoryForSmartcut,
        GetScheduledTriggersForSmartcut: GetScheduledTriggersForSmartcut,
        FindExecutionById: FindExecutionById,
        UpdateExecutionStatus: UpdateExecutionStatus,
        UpsertExecutionSet: UpsertExecutionSet,
        DeleteExecutionSet: DeleteExecutionSet,
        GetExecutionSetProgress: GetExecutionSetProgress,
        GetExecutionSetById: GetExecutionSetById,
        UpsertScheduledTriggerAndCreateAlarm: UpsertScheduledTriggerAndCreateAlarm,
        ArchiveScheduledTrigger: ArchiveScheduledTrigger,
        SaveExternalAccount: SaveExternalAccount,
        FindExternalAccountById: FindExternalAccountById,
        GetOAuthToken: GetOAuthToken,
        AskBgToClipboard: AskBgToClipboard,
        CreateGoogleSheet: CreateGoogleSheet,
        FetchGoogleSheet: FetchGoogleSheet,
        BatchUpdateGoogleSheet: BatchUpdateGoogleSheet,
        InitGoogleAuthFlow: InitGoogleAuthFlow,
        UserDidCloseGoogleOAuthModal: UserDidCloseGoogleOAuthModal,
        MultiUrlTriggering: {
          stringifyMessage: stringifyMessage$65,
          stringifyResponse: stringifyResponse$65
        },
        DebugSelector: DebugSelector,
        PlaybackModeControl: PlaybackModeControl,
        UrlTriggering_AskBgToUpdateLinkGroups: UrlTriggering_AskBgToUpdateLinkGroups,
        UrlTriggering_AskBgToRecordPageAction: UrlTriggering_AskBgToRecordPageAction,
        UrlTriggering_AskBgToStopRecordPageAction: UrlTriggering_AskBgToStopRecordPageAction,
        UrlTriggering_AskBgToPlaybackPageAction: UrlTriggering_AskBgToPlaybackPageAction,
        UrlTriggering_DidFinishPlaybackPageAction: UrlTriggering_DidFinishPlaybackPageAction$1,
        UrlTriggering_AskBgToShowLinkWithId: UrlTriggering_AskBgToShowLinkWithId,
        UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut: UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut,
        UrlTriggering_MaybeReadyToPlaybackPagination: UrlTriggering_MaybeReadyToPlaybackPagination,
        UrlTriggering_AskBgToUpdatePaginateFn: UrlTriggering_AskBgToUpdatePaginateFn,
        AskBgToFocusTab: AskBgToFocusTab,
        AskBgToFocusWindow: AskBgToFocusWindow,
        SmartcutSavingProgress: SmartcutSavingProgress,
        RequestPermissions: RequestPermissions,
        NotifyConfirmExecutionQuotaResult: NotifyConfirmExecutionQuotaResult,
        TrackWithSegment: TrackWithSegment,
        UserReadyLogInToWebsite: UserReadyLogInToWebsite,
        OpenNewWindow: OpenNewWindow,
        StoreAuthStatusItem: StoreAuthStatusItem,
        AskBgToHighlightElement: AskBgToHighlightElement,
        DidCloseExplainModalAndAskBgToHighlightElement: DidCloseExplainModalAndAskBgToHighlightElement,
        AskBgToStopHighlightElement: AskBgToStopHighlightElement,
        GetUserCredentials: GetUserCredentials,
        UnlockVaultWithMasterSecret: UnlockVaultWithMasterSecret,
        ModifyUserCredentials: ModifyUserCredentials,
        AskBgIfMasterSecretDoesExist: AskBgIfMasterSecretDoesExist,
        AskBgForMissingPasswords: AskBgForMissingPasswords,
        AskBgToCreateVaultWithMasterSecret: AskBgToCreateVaultWithMasterSecret,
        AskBgToResetMasterSecret: AskBgToResetMasterSecret,
        AskBgToDetachLoginSmartcut: AskBgToDetachLoginSmartcut,
        AskBgToEnterDataExtractionMode: AskBgToEnterDataExtractionMode,
        AskBgToProcessDataExtractionSignal: AskBgToProcessDataExtractionSignal,
        AskBgToExitFromDataExtractionMode: AskBgToExitFromDataExtractionMode,
        AskBgToRenderNotification: AskBgToRenderNotification,
        AskBgToSaveDataExtractionAsSmartcut: AskBgToSaveDataExtractionAsSmartcut,
        All: All$1,
        AllAll: AllAll
      }
    });

exports.ContentScript__StateMachine__PlaybackMode__Types__Helpers = ContentScript__StateMachine__PlaybackMode__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers = ContentScript__StateMachine__RecordingMode__ContentEditing__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers = ContentScript__StateMachine__RecordingMode__EventStreaming__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers = ContentScript__StateMachine__RecordingMode__GoogleSheets__Types__Helpers;
exports.ContentScript__StateMachine__RecordingMode__Types__Helpers = ContentScript__StateMachine__RecordingMode__Types__Helpers;
exports.ContentScript__StateMachine__Shared__Types__Helpers = ContentScript__StateMachine__Shared__Types__Helpers;
exports.ContentScript__StateMachine__Types__Helpers = ContentScript__StateMachine__Types__Helpers;
exports.ExtensionMessagingLogging = ExtensionMessagingLogging;
/* ContentScript__StateMachine__PlaybackMode__Types__Helpers Not a pure module */
